// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAFLSURBVHgBnZLfTcMwEMbv7Lhx/RQ2sASuEC+UDdoNwgSUDViBDWCCZgPYoGWC8ogEEt6APiGranLYSaiqJqmqfJJj6/78fPlkhD0liU6cEykA6ipSLJ37WsIR4f9BqfOUcj73keSgxhJsps5Z2wZgu+aCv9TEx20e3RCwKUN69iGNJFZCmDF0aShH32FJqfVhLjT6HA2lWbQ2KzVKQ4GUZtZ5wdA8VTXNC1hRQDlansN7F4CI1zkxaQCIcA0ni9sGADEv6Zxj2tXGoJhUJ2dbC0oTY/PT5nQcXzzUHs3beqPw2eZ0GzFcRBxWnJvMh97q/B0CTqop2rV7SFJeaobFKxFc7xcQUMYAkUoYZb/u874xQfl37sP6bSzElV9bHWKDwWa5XtvSZCVHHoYzJQ0cQk6Wh2TBD9XhRy8IQg8FSPAklpsz6Ktgetj/ANwtaoEESpAOAAAAAElFTkSuQmCC", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
.DarkTheme {
  /* Style the scrollbar thumb */
  /* Style the scrollbar on hover */
  /* Rounded sliders */
  /* width */
  /* Track */
  /* Handle */
  /* Handle on hover */
  /* for actions dropdown */
}
.DarkTheme text {
  fill: white !important;
}
.DarkTheme .main-wrapper {
  transition: all 0.25s ease-in;
  overflow: hidden;
  position: relative;
  margin: 0;
  padding: 0;
  background: var(--foundation-neutral-dark-theme-neutral-dark-theme-900, #1F2020);
  min-height: 100vh;
  transition: all 0.2s ease-in-out;
  max-height: 100vh;
}
.DarkTheme .content-body {
  margin-left: 15rem;
  margin-bottom: 1rem;
  margin-right: 1rem;
  border-radius: 14px;
}
.DarkTheme .content-body-collapse {
  margin-left: 6rem;
  background: var(--foundation-neutral-dark-theme-neutral-dark-theme-700, #343535);
  transition: margin-left 0.4s ease;
  margin-bottom: 1rem;
  margin-right: 1rem;
  border-radius: 14px;
  margin-top: 1rem;
}
.DarkTheme .text-custom {
  color: white;
}
.DarkTheme .table-custom {
  background: var(--foundation-neutral-dark-theme-neutral-dark-theme-700, #343535);
  height: 89vh;
  border-radius: 12px;
}
.DarkTheme .rdt_Table, .DarkTheme .rdt_TableHeader, .DarkTheme .rdt_ExpanderRow {
  background: var(--foundation-neutral-dark-theme-neutral-dark-theme-700, #343535);
  color: var(--text-white-high-emphasis, #FCFCFE);
}
.DarkTheme .rdt_Table > div {
  background: var(--foundation-neutral-dark-theme-neutral-dark-theme-700, #343535);
  color: var(--text-white-high-emphasis, #FCFCFE);
}
.DarkTheme .rdt_TableRow {
  min-height: 60px !important;
}
.DarkTheme .shift-table .rdt_TableRow {
  border-bottom: 2px solid var(--neutral-dark-400) !important;
}
.DarkTheme .rdt_TableCell {
  padding-left: 5px !important;
  padding-right: 5px !important;
}
.DarkTheme .rdt_TableHeadRow {
  background: #494B4B !important;
  min-height: 38px !important;
  border-radius: 12px;
}
.DarkTheme .rdt_TableBody {
  overflow: scroll;
  height: calc(100vh - 277px);
  padding-bottom: 60px;
  padding-right: 8px;
  background: var(--foundation-neutral-dark-theme-neutral-dark-theme-700, #343535);
}
.DarkTheme .rdt_TableHead {
  background: var(--foundation-neutral-dark-theme-neutral-dark-theme-700, #343535) !important;
  color: var(--text-white-high-emphasis, #FCFCFE);
}
.DarkTheme .rdt_TableBody {
  background: var(--foundation-neutral-dark-theme-neutral-dark-theme-700, #343535);
  color: var(--text-white-high-emphasis, #FCFCFE);
}
.DarkTheme .rdt_TableRow {
  background: var(--foundation-neutral-dark-theme-neutral-dark-theme-700, #343535);
  color: var(--text-white-high-emphasis, #FCFCFE);
  border-bottom: none !important;
}
.DarkTheme .rdt_TableRow button[aria-label="Expand Row"], .DarkTheme .rdt_TableRow button[aria-label="Collapse Row"] {
  color: var(--text-white-high-emphasis, #FCFCFE);
}
.DarkTheme .bMuwEY {
  border-radius: 0 !important;
}
.DarkTheme .iGDrkx {
  background: var(--foundation-neutral-dark-theme-neutral-dark-theme-700, #343535) !important;
}
.DarkTheme .button-toggle {
  margin-right: -1.8rem;
  color: black;
}
.DarkTheme .nav-options-nested-option {
  color: var(--text-white-high-emphasis, #FCFCFE);
  border-radius: 14px;
  font-family: Inter;
  font-size: 0.7rem;
  font-style: normal;
  font-weight: 600;
  line-height: 120%;
  margin-top: -45px;
  margin-bottom: 15px;
  margin-left: 39px;
}
.DarkTheme .nav-options {
  color: var(--text-white-high-emphasis, #FCFCFE);
  border-radius: 14px;
  font-family: Inter;
  font-size: 0.8rem;
  font-style: normal;
  font-weight: 600;
  line-height: 120%;
}
.DarkTheme .nav-options-hovered {
  color: black;
  background: var(--primary);
  border-radius: 14px;
  /* Typography/Body/Default/Bold */
  font-family: Inter;
  font-size: 0.8rem;
  font-style: normal;
  font-weight: 600;
  line-height: 120%; /* 16.8px */
  width: 11.9rem;
}
.DarkTheme .nav-options:hover {
  background: var(--primary);
  color: black;
  font-weight: 600;
}
.DarkTheme .toggleSwitch {
  background: var(--foundation-neutral-neutral-500, #DCE4F1);
}
.DarkTheme .nav-options-nested {
  color: var(--text-white-high-emphasis, #FCFCFE);
  border-radius: 14px;
  /* Typography/Body/Default/Bold */
  font-family: Inter;
  font-size: 0.6rem;
  font-style: normal;
  font-weight: 600;
  line-height: 120%; /* 16.8px */
}
.DarkTheme .nav-options-nested:hover {
  background: var(--primary);
  color: black;
  font-weight: 600;
}
.DarkTheme .banner {
  margin: 1rem;
  margin-left: 15rem;
  background: linear-gradient(269deg, var(--primary) 14.5%, var(--secondary-700) 87.34%, var(--secondary-700) 87.34%);
}
.DarkTheme .banner-collapse {
  margin: 1rem;
  margin-left: 6rem;
  background: linear-gradient(269deg, var(--primary) 14.5%, var(--secondary-700) 87.34%, var(--secondary-700) 87.34%);
}
.DarkTheme .txt-title {
  color: var(--text-white-high-emphasis, #FCFCFE);
  /* Typography/Heading 5/Bold */
  font-size: 1rem;
  font-style: normal;
  font-weight: 600;
  line-height: 120%; /* 28.8px */
}
.DarkTheme .btn-banner {
  border: 2px solid rgba(255, 255, 255, 0.8);
  background: var(--foundation-secondary-secondary-400, var(--primary));
  box-shadow: 0px 10px 31px 0px var(--primary-opactiy-40);
  color: #323146;
  /* Typography/Body/Default/Bold */
  font-family: Inter;
  font-size: 0.7rem;
  font-style: normal;
  font-weight: 600;
  line-height: 120%; /* 16.8px */
}
.DarkTheme .headerTop {
  margin-left: 12rem;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  border-bottom: 1px solid #494B4B;
}
.DarkTheme .headerTop-collapse {
  margin-left: 4rem;
  border-bottom: 1px solid #494B4B;
  display: flex;
  align-items: center;
  justify-content: flex-end;
}
.DarkTheme .fa-chevron-down {
  color: var(--text-white-medium-emphasis, rgba(252, 252, 254, 0.6));
}
.DarkTheme .fa-circle {
  font-size: 8px;
}
.DarkTheme .fa-circle-question {
  color: var(--text-white-high-emphasis, #FCFCFE);
}
.DarkTheme .headerSecond {
  margin-left: 14rem;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.DarkTheme .headerSecond-collapse {
  margin-left: 5rem;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.DarkTheme .image-logo {
  border: 2px solid var(--foundation-neutral-neutral-400, #494B4B);
}
.DarkTheme .fa-lock {
  color: var(--text-white-medium-emphasis, rgba(252, 252, 254, 0.6));
  font-size: 10px;
}
.DarkTheme .image-logo-second {
  color: var(--text-white-high-emphasis, #FCFCFE);
  /* Typography/Heading 5/Bold */
  font-size: 1rem;
  font-style: normal;
  font-weight: 600;
  line-height: 120%; /* 28.8px */
}
.DarkTheme .groupid {
  color: var(--text-white-medium-emphasis, rgba(252, 252, 254, 0.6));
  /* Typography/Body/Default/Regular */
  font-family: Inter;
  font-size: 0.6rem;
  font-style: normal;
  font-weight: 400;
  line-height: 130%; /* 18.2px */
}
.DarkTheme .bell {
  border: 2px solid var(--foundation-neutral-dark-theme-neutral-dark-theme-500, #494B4B);
}
.DarkTheme .fa-bell {
  color: var(--text-white-high-emphasis, #FCFCFE);
}
.DarkTheme .sub-grp {
  border-radius: 14px;
  border: 2px solid var(--primary);
  background: var(--foundation-secondary-secondary-400, var(--primary));
  color: var(--text-high-emphasis, #090826);
  font-family: Inter;
  font-size: 0.8rem;
  font-style: normal;
  font-weight: 600;
  line-height: 120%;
}
.DarkTheme .delete-obj {
  background: var(--Error-error-button-enabled, #FF6969);
  box-shadow: 0px 10px 31px 0px rgba(255, 105, 105, 0.4);
  font-weight: 600;
}
.DarkTheme .sub-grp:hover {
  background: var(--secondary-300);
}
.DarkTheme .notificationcard {
  position: absolute;
  /* bottom:0; */
  top: 18px;
  right: 0;
  z-index: 1000;
  width: 300px;
  border-radius: 14px;
  border: 1px solid var(--foundation-neutral-neutral-400, #E3E9F4);
  background: #FFF;
  /* popover */
  box-shadow: 10px 14px 74px 0px rgba(92, 96, 101, 0.2);
}
.DarkTheme .bgOne {
  background: var(--foundation-neutral-neutral-500, #DCE4F1);
}
.DarkTheme .notification {
  color: var(--text-high-emphasis, #090826);
  /* Typography/Body/Large/Regular */
  font-size: 0.7rem;
  font-style: normal;
  font-weight: 400;
  line-height: 120%;
  text-align: left;
  z-index: 100000000;
}
.DarkTheme .notification-card {
  border-top: 1px solid #E3E9F4;
}
.DarkTheme .notification-card:hover {
  border-radius: 14px;
  background: var(--foundation-neutral-neutral-400, #E3E9F4);
}
.DarkTheme .notification-img {
  border: 2px solid var(--foundation-neutral-neutral-400, #E3E9F4);
  height: 40px;
  min-width: 40px;
}
.DarkTheme .notification-heading {
  color: white;
  /* Typography/Heading 6/Bold */
  font-family: Inter;
  text-align: left;
  font-size: 0.8rem;
  font-style: normal;
  font-weight: 600;
  line-height: 120%; /* 24px */
}
.DarkTheme .notification-description {
  color: var(--text-medium-emphasis, rgba(9, 8, 38, 0.6));
  text-align: left;
  /* Typography/Body/Default/Regular */
  font-family: Inter;
  font-size: 0.8rem;
  font-style: normal;
  font-weight: 400;
  line-height: 130%; /* 18.2px */
}
.DarkTheme .profile {
  z-index: 1000;
}
.DarkTheme .profile-name {
  /* Typography/Body/Default/Bold */
  font-family: Inter;
  font-size: 0.8rem;
  font-style: normal;
  font-weight: 600;
  line-height: 120%; /* 16.8px */
}
.DarkTheme .isactive {
  /* Typography/Body/Default/Regular */
  font-family: Inter;
  font-size: 0.7rem;
  font-style: normal;
  font-weight: 400;
  line-height: 130%; /* 18.2px */
}
.DarkTheme .profileCards {
  border-top: 1px solid #E3E9F4;
  /* Typography/Body/Default/Regular */
  font-family: Inter;
  font-size: 0.8rem;
  font-style: normal;
  font-weight: 400;
  line-height: 130%; /* 18.2px */
}
.DarkTheme .profilehover:hover {
  border-radius: 14px;
  background: var(--foundation-neutral-neutral-400, #777777);
}
.DarkTheme .profileCards {
  display: flex;
  flex-direction: column;
}
.DarkTheme .theader {
  color: white;
}
.DarkTheme .rdt_TableHeader {
  background: var(--foundation-neutral-dark-theme-neutral-dark-theme-700, #343535);
}
.DarkTheme .lffUrX:not(:last-of-type) {
  border: none !important;
}
.DarkTheme .tab {
  border-radius: 14px;
  background: var(--primary-opactiy-20);
  /* Typography/Body/Default/Bold */
  font-family: Inter;
  font-size: 14px;
  font-style: normal;
  font-weight: 600;
  line-height: 120%; /* 16.8px */
  color: var(--secondary-200);
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  gap: 12px;
  /* Typography/Body/Default/Bold */
  position: relative;
}
.DarkTheme .type-roles {
  display: flex;
  padding: 4px 6px 4px 7px;
  align-items: center;
  justify-content: space-between;
  border-radius: 54px;
  border: 2px solid #C8CFDB;
  background: #E3E9F4;
  color: #090826;
  width: 129px;
  /* Typography/Body/Small/Regular */
  font-family: Inter;
  font-size: 0.8rem;
  font-style: normal;
  font-weight: 400;
  line-height: 120%; /* 14.4px */
}
.DarkTheme .type-pending-provision {
  cursor: pointer;
  display: flex;
  padding: 4px 16px 4px 12px;
  align-items: center;
  gap: 8px;
  border-radius: 54px;
  border: 2px solid rgba(246, 182, 55, 0.5019607843);
  background: rgba(246, 182, 55, 0.2);
  color: #87641E;
  /* Typography/Body/Small/Regular */
  font-family: Inter;
  font-size: 0.8rem;
  font-style: normal;
  font-weight: 400;
  line-height: 120%; /* 14.4px */
}
.DarkTheme .type-requested {
  cursor: pointer;
  display: flex;
  padding: 4px 16px 4px 12px;
  align-items: center;
  gap: 8px;
  border-radius: 54px;
  border: 2px solid var(--secondary-300) 80;
  background: rgba(246, 182, 55, 0.2);
  color: #87641E;
  /* Typography/Body/Small/Regular */
  font-family: Inter;
  font-size: 0.8rem;
  font-style: normal;
  font-weight: 400;
  line-height: 120%; /* 14.4px */
}
.DarkTheme .tab.form {
  color: var(--secondary-500);
}
.DarkTheme .tab::before {
  content: "";
  position: absolute;
  height: 4px;
  bottom: 0;
  border-radius: 20px;
  width: 70%;
  align-self: center;
  background-color: var(--secondary-500);
}
.DarkTheme .tab.form::before {
  position: absolute;
  height: 4px;
  bottom: 0;
  border-radius: 20px;
  width: 70%;
  align-self: center;
  background-color: var(--secondary-50);
}
.DarkTheme .tab-unactive {
  color: var(--text-white-medium-emphasis, rgba(252, 252, 254, 0.6));
  align-self: center;
  justify-self: center;
  /* Typography/Body/Default/Bold */
  font-family: Inter;
  font-size: 0.8rem;
  font-style: normal;
  font-weight: 600;
  line-height: 130%; /* 18.2px */
}
.DarkTheme input:focus {
  padding: none;
  outline: none !important;
}
.DarkTheme .search-input::placeholder {
  color: var(--text-white-low-emphasis, rgba(252, 252, 254, 0.32));
  /* Typography/Body/Default/Regular */
  font-family: Inter;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 130%; /* 18.2px */
  text-align: right;
}
.DarkTheme .custom-input:disabled {
  background-color: rgba(67, 67, 67, 0.7);
  opacity: 1;
}
.DarkTheme .custom-input::placeholder {
  /* Typography/Body/Default/Bold */
  font-family: Inter;
  font-size: 0.8rem;
  font-style: normal;
  font-weight: 400;
  line-height: 120%; /* 16.8px */
}
.DarkTheme .search-input, .DarkTheme .custom-input {
  padding-right: 20px;
  border-radius: 14px;
  border: 2px solid var(--foundation-neutral-dark-theme-neutral-dark-theme-500, #494B4B);
  font-size: 0.8rem;
  background-color: transparent;
  color: rgb(255, 255, 255);
}
.DarkTheme .fa-search, .DarkTheme .fa-arrow-down-short-wide, .DarkTheme .dark-optimise {
  color: var(--text-white-high-emphasis, #FCFCFE);
}
.DarkTheme .text-style {
  color: var(--text-white-high-emphasis, #FCFCFE);
  /* Typography/Body/Default/Bold */
  font-family: Inter;
  font-size: 0.8rem;
  font-style: normal;
  font-weight: 400;
  line-height: 120%; /* 16.8px */
}
.DarkTheme .celVQH {
  overflow-y: auto;
  max-height: 28vh;
}
@media (min-width: 1600px) {
  .DarkTheme .celVQH {
    overflow-y: auto;
    max-height: 45vh;
  }
  .DarkTheme .permission-page {
    overflow: scroll;
    height: 55vh;
  }
}
.DarkTheme .iGDrkx {
  min-height: 0px !important;
  padding: 0 !important;
}
.DarkTheme .fa-chevron-right {
  color: var(--text-medium-emphasis, rgba(9, 8, 38, 0.6));
}
.DarkTheme .lffUrX {
  min-height: 60px !important;
}
.DarkTheme .text-heading {
  font-size: 0.8rem;
  font-style: normal;
  font-weight: 600;
  line-height: 120%;
  word-break: normal !important;
  max-width: 6vw;
  /* white-space: nowrap; */
  overflow: hidden;
  text-overflow: ellipsis;
}
.DarkTheme .desc-box {
  max-width: 14vw;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.DarkTheme .text-detail {
  color: var(--text-white-high-emphasis, #FCFCFE);
  font-size: 0.7rem;
  font-style: normal;
  font-weight: 400;
  line-height: 120%; /* 14.4px */
}
.DarkTheme .type-department {
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 8px;
  border-radius: 54px;
  border: 2px solid rgba(255, 205, 175, 0.5);
  background: rgba(255, 205, 175, 0.2);
  padding: 4px 16px 4px 12px;
  /* Typography/Body/Small/Regular */
  color: var(--foundation-orange-orange-200, #FFCDAF);
  font-family: Inter;
  font-size: 0.8rem;
  font-style: normal;
  font-weight: 400;
  line-height: 120%; /* 14.4px */
}
.DarkTheme .type-project {
  display: flex;
  padding: 4px 16px 4px 12px;
  align-items: center;
  gap: 8px;
  border-radius: 54px;
  color: var(--foundation-purple-purple-200, #D2BCFC);
  border: 2px solid rgba(210, 188, 252, 0.5);
  background: rgba(210, 188, 252, 0.2);
  /* Typography/Body/Small/Regular */
  font-family: Inter;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 120%; /* 14.4px */
}
.DarkTheme .type-initiated {
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 8px;
  border-radius: 54px;
  border: 2px solid var(--secondary-300);
  background: #d4ebf2;
  color: #3590ae;
  padding: 4px 16px 4px 12px;
  /* Typography/Body/Small/Regular */
  font-family: Inter;
  font-size: 0.8rem;
  font-style: normal;
  font-weight: 400;
  line-height: 120%; /* 14.4px */
}
.DarkTheme .type-Client {
  cursor: pointer;
  display: flex;
  padding: 4px 16px 4px 12px;
  align-items: center;
  gap: 8px;
  border-radius: 54px;
  border: 2px solid rgba(186, 238, 138, 0.5);
  background: rgba(186, 238, 138, 0.2);
  color: var(--foundation-green-green-200, #BAEE8A);
  /* Typography/Body/Small/Regular */
  font-family: Inter;
  font-size: 0.8rem;
  font-style: normal;
  font-weight: 400;
  line-height: 120%; /* 14.4px */
}
.DarkTheme .folder {
  text-align: center; /* 19.2px */
  color: var(--text-low-emphasis, rgba(9, 8, 38, 0.32));
  /* Typography/Body/Default/Bold */
  font-family: Inter;
  font-size: 0.8rem;
  font-style: normal;
  font-weight: 600;
  line-height: 120%; /* 16.8px */
}
.DarkTheme .setting {
  color: var(--text-high-emphasis, #090826);
  width: 120px;
  /* Typography/Body/Default/Bold */
  font-family: Inter;
  font-size: 0.8rem;
  font-style: normal;
  font-weight: 500;
  line-height: 120%; /* 16.8px */
}
.DarkTheme .member {
  color: var(--text-medium-emphasis, rgba(9, 8, 38, 0.6));
  text-align: center;
  font-size: 0.8rem;
  font-style: normal;
  font-weight: 400;
  line-height: 120%; /* 19.2px */
}
.DarkTheme .folder-0 {
  color: var(--text-low-emphasis, rgba(9, 8, 38, 0.32));
  /* Typography/Body/Default/Bold */
  font-family: Inter;
  font-size: 0.8;
  font-style: normal;
  font-weight: 500;
  line-height: 120%; /* 16.8px */
}
.DarkTheme .setting-0 {
  color: var(--text-low-emphasis, rgba(9, 8, 38, 0.32));
  text-align: center;
  width: 120px;
  font-size: 0.8rem;
  font-style: normal;
  font-weight: 400;
  line-height: 120%; /* 19.2px */
}
.DarkTheme .cQAWmj {
  /* height: 20px!important; */
  min-height: 0px !important;
}
.DarkTheme .lhMoHC {
  min-width: 50px !important;
}
.DarkTheme .lffUrX:hover {
  background: var(--foundation-neutral-dark-theme-neutral-dark-theme-600, #424444) !important;
  border-radius: 14px !important;
}
.DarkTheme .Navheader {
  width: 13.7rem;
  transition: width 0.4s ease;
  background: #002d72;
  position: fixed;
  top: 0;
  bottom: 0;
  z-index: 9;
}
.DarkTheme .Navheader-collapse {
  width: 5rem;
  transition: width 0.4s ease;
  background: #002d72;
  position: fixed;
  top: 0;
  bottom: 0;
  z-index: 1000000000;
}
.DarkTheme .dbtez {
  /* width: 11.5rem; */
  width: 8.5rem;
  transition: width 0.4s ease;
}
.DarkTheme .icon {
  width: 40px;
  font-size: 1.3rem;
  transition: width 0.4s ease;
}
.DarkTheme .icon-collapse {
  font-size: 1.1rem;
  width: auto;
  transition: width 0.4s ease;
}
.DarkTheme .navoptionsall::-webkit-scrollbar-track {
  background-color: var(--foundation-neutral-dark-theme-neutral-dark-theme-500, #494B4B); /* Change this to match your sidebar's background color */
  padding-left: 10px;
}
.DarkTheme .navoptionsall::-webkit-scrollbar-thumb {
  background-color: #666; /* Change this to match the color you want for the scrollbar thumb */
  border-radius: 10px; /* Adjust border radius as needed */
}
.DarkTheme .navoptionsall::-webkit-scrollbar-thumb:hover {
  background-color: #999; /* Change this to a lighter shade for hover effect */
}
.DarkTheme .navoptionsall {
  margin-top: 33px;
  height: 80vh;
  width: auto;
  transition: width 0.4s ease;
  margin-right: 5px;
}
.DarkTheme .dbtez {
  /* border-radius: 14px; */
  border: 2px solid var(--foundation-neutral-dark-theme-neutral-dark-theme-300, #858686);
  background: rgba(255, 255, 255, 0.2);
  align-items: center;
}
.DarkTheme .row-label {
  color: white !important;
  /* Typography/Body/Default/Bold */
  font-size: 0.7rem;
  font-style: normal;
  font-weight: 600;
  line-height: 120%; /* 16.8px */
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
}
.DarkTheme .setting-0 {
  color: var(--text-white-medium-emphasis, rgba(252, 252, 254, 0.6)) !important;
}
.DarkTheme .not-0, .DarkTheme .setting {
  color: var(--text-white-high-emphasis, #FCFCFE);
}
.DarkTheme .fEnJOm {
  min-height: 0 !important;
  display: flex;
  /* padding: 8px 16px 8px 64px; */
  align-items: center;
  align-self: stretch;
  margin: 4px;
  margin-top: 12px;
  border-bottom: none !important;
  border-radius: 14px !important;
  padding-top: 2px;
  padding-bottom: 2px;
  background: var(--foundation-neutral-dark-theme-neutral-dark-theme-600, #424444) !important;
}
.DarkTheme .navoptionsallcollapse {
  height: 80vh;
  overflow-y: scroll;
  margin-top: 33px;
  width: auto;
  transition: width 0.4s ease;
  margin-right: 5px;
  border-top: none;
  z-index: 2000000 !important;
}
.DarkTheme .navoptionsallcollapse .optionsDropdownCard {
  background: linear-gradient(var(--primary-opactiy-20), var(--primary-opactiy-20)), linear-gradient(var(--foundation-neutral-dark-theme-neutral-dark-theme-500, #494B4B), var(--foundation-neutral-dark-theme-neutral-dark-theme-500, #494B4B)) top;
  border-radius: 14px;
  transform: translate(60px, -50%);
}
.DarkTheme .navoptionsallcollapse .nav-options.activeOption {
  z-index: 9999999 !important;
}
.DarkTheme .navoptionsallcollapse:has(.optionsDropdownCard) {
  overflow-y: visible;
  position: relative;
  z-index: -1 !important;
}
.DarkTheme .rdt_Pagination {
  border-radius: 14px !important;
  background: var(--foundation-neutral-dark-theme-neutral-dark-theme-600, #424444) !important;
  color: var(--text-white-medium-emphasis, rgba(252, 252, 254, 0.6)) !important;
}
.DarkTheme .rdt_Pagination button {
  color: rgba(252, 252, 254, 0.54);
  fill: rgba(252, 252, 254, 0.54);
}
.DarkTheme .rdt_Pagination button:disabled {
  color: rgba(252, 252, 254, 0.18);
  fill: rgba(252, 252, 254, 0.18);
}
.DarkTheme .kZkdeH:disabled {
  color: var(--text-white-high-emphasis, #FCFCFE);
}
.DarkTheme .kZkdeH {
  color: var(--text-white-high-emphasis, #FCFCFE) !important;
}
.DarkTheme .options-dropdown {
  width: 10.5rem;
}
.DarkTheme .options-heading {
  overflow: hidden;
  color: white;
  /* text-overflow: unset; */
  margin-left: 23px;
  font-family: Inter;
  font-size: 0.8rem;
  font-style: normal;
  font-weight: 600;
  line-height: 120%;
}
.DarkTheme .nav-options-heading {
  overflow: hidden;
  color: white;
  /* text-overflow: unset; */
  margin-left: 23px;
  font-family: Inter;
  font-size: 0.8rem;
  font-style: normal;
  font-weight: 600;
  line-height: 120%;
}
.DarkTheme .roles-heading {
  color: white;
  margin-left: 23px;
  font-family: Inter;
  font-size: 0.8rem;
  font-style: normal;
  font-weight: 600;
  line-height: 120%;
}
.DarkTheme .textBlack {
  color: black;
}
.DarkTheme .options-heading-submenu {
  overflow: hidden;
  /* text-overflow: unset; */
  margin-left: 23px;
  font-family: Inter;
  font-size: 0.8rem;
  font-style: normal;
  font-weight: 600;
  line-height: 120%;
}
.DarkTheme .options-heading-active {
  overflow: hidden;
  color: black;
  /* text-overflow: unset; */
  margin-left: 23px;
  font-family: Inter;
  font-size: 0.8rem;
  font-style: normal;
  font-weight: 600;
  line-height: 120%;
}
.DarkTheme .optionsDropdownCard {
  margin-top: -20px;
  /* position: relative;
  bottom: 0; */
  /* top: 255px; */
  font-size: 18px;
  /* left: 9px; */
  z-index: 9999999;
  /* color: white; */
  width: 11.8rem;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  border-bottom-left-radius: 14px;
  border-bottom-right-radius: 14px;
  background: var(--primary-opactiy-20);
  border: 1px solid var(--primary-opactiy-20);
  box-shadow: 10px 14px 74px 0px var(--primary-opactiy-10);
}
.DarkTheme .options-dropdown {
  /* width: 11.5rem; */
  width: 8.5rem;
}
.DarkTheme .activeOption {
  border-radius: 14px;
  background: var(--primary);
  color: black;
  /* background: var(--primary-opactiy-20); */
  /* color: #333; */
  /* background-image: url(data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjAiIGhlaWdodD0iMjAiIHZpZXdCb3g9IjAgMCAyMCAyMCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPG1hc2sgaWQ9Im1hc2swXzI1NzlfNzc2MjAiIHN0eWxlPSJtYXNrLXR5cGU6YWxwaGEiIG1hc2tVbml0cz0idXNlclNwYWNlT25Vc2UiIHg9IjAiIHk9IjAiIHdpZHRoPSIyMCIgaGVpZ2h0PSIyMCI+CjxyZWN0IHdpZHRoPSIyMCIgaGVpZ2h0PSIyMCIgZmlsbD0iI0Q5RDlEOSIvPgo8L21hc2s+CjxnIG1hc2s9InVybCgjbWFzazBfMjU3OV83NzYyMCkiPgo8cGF0aCBkPSJNOC4yMjkxNyAxMS45Mzc1TDEzLjcyOTIgNi40NTgzNEMxMy44ODE5IDYuMzA1NTYgMTQuMDU1NiA2LjIzMjY0IDE0LjI1IDYuMjM5NTlDMTQuNDQ0NCA2LjI0NjUzIDE0LjYxODEgNi4zMjYzOSAxNC43NzA4IDYuNDc5MTdDMTQuOTIzNiA2LjYzMTk1IDE1IDYuODA1NTYgMTUgNy4wMDAwMUMxNSA3LjE5NDQ1IDE0LjkyMzYgNy4zNjgwNiAxNC43NzA4IDcuNTIwODRMOC43NzA4MyAxMy41MjA4QzguNjE4MDYgMTMuNjczNiA4LjQ0MDk3IDEzLjc1IDguMjM5NTggMTMuNzVDOC4wMzgxOSAxMy43NSA3Ljg2MTExIDEzLjY3MzYgNy43MDgzMyAxMy41MjA4TDUuMjI5MTcgMTEuMDQxN0M1LjA3NjM5IDEwLjg4ODkgNSAxMC43MTUzIDUgMTAuNTIwOEM1IDEwLjMyNjQgNS4wNzYzOSAxMC4xNTI4IDUuMjI5MTcgMTBDNS4zODE5NCA5Ljg0NzIzIDUuNTU1NTYgOS43NzA4NCA1Ljc1IDkuNzcwODRDNS45NDQ0NCA5Ljc3MDg0IDYuMTE4MDYgOS44NDcyMyA2LjI3MDgzIDEwTDguMjI5MTcgMTEuOTM3NVoiIGZpbGw9IiMwOTA4MjYiLz4KPC9nPgo8L3N2Zz4K); */
  background-repeat: no-repeat;
  background-position: left;
}
.DarkTheme .options-heading {
  overflow: hidden;
  color: white;
  /* text-overflow: unset; */
  margin-left: 23px;
  font-family: Inter;
  font-size: 0.8rem;
  font-style: normal;
  font-weight: 600;
  line-height: 120%;
}
.DarkTheme .organisationDropdownCard {
  z-index: 200000000 !important;
  position: absolute;
  /* bottom:0; */
  /* top: 40px;
  left: 20px; */
  left: 0;
  top: 92%;
  width: 11rem;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  border-radius: 14px;
  color: white;
  border: 2px solid var(--foundation-neutral-neutral-400, #494B4B);
  background: var(--main-neutral-dark-theme-neutral-dark-theme-700, #343535) !important;
  /* popover */
  box-shadow: 10px 14px 74px 0px rgba(92, 96, 101, 0.2);
}
.DarkTheme .organisationDropdownCard > div {
  width: 100%;
}
.DarkTheme .plus-icon {
  margin-left: 16px;
  color: white;
}
.DarkTheme .organisations {
  max-height: 40vh;
  overflow: auto;
  border-top: 2px solid #494B4B;
  border-bottom: 2px solid #494B4B;
  border-color: #494B4B;
}
.DarkTheme .select-custom-input {
  flex: 1 1;
  padding: 10px;
  box-sizing: border-box;
  border: 2px solid #494B4B;
  border-radius: 12px;
  background: var(--main-neutral-dark-theme-neutral-dark-theme-700, #343535) !important;
  width: 425px;
  margin-bottom: 15px;
}
.DarkTheme .organisation-img {
  width: 23px;
  border: 1px solid #E3E9F4;
  padding: 2px;
}
.DarkTheme .organisation-heading {
  overflow: hidden;
  color: #fff;
  text-overflow: ellipsis;
  font-family: Inter;
  font-size: 0.8rem;
  font-style: normal;
  font-weight: 600;
  /* line-height: 120%; */
}
.DarkTheme .oragnisationHover:hover {
  border-radius: 14px;
  background: var(--primary);
  color: black !important;
}
.DarkTheme .oragnisationHover {
  cursor: pointer;
}
.DarkTheme .oragnisationHover button {
  font-size: 10px;
  color: rgba(9, 8, 38, 0.3215686275);
  display: block;
}
.DarkTheme .oragnisationHover button i {
  display: block;
}
.DarkTheme .new:hover {
  cursor: pointer;
}
.DarkTheme .nav-options {
  position: relative;
}
.DarkTheme .tooltip {
  display: flex;
  position: absolute;
  background: #000000;
  color: var(--text-high-emphasis, #090826);
  gap: 8px;
  font-family: Inter;
  font-size: 0.8rem;
  font-style: normal;
  font-weight: 400;
  line-height: 130%;
  padding: 5px;
  width: max-content;
  border-radius: 4px;
  top: 10px;
  left: 50px;
  z-index: 90000000000000 !important;
  text-align: justify;
  /* display: inline-block; */
}
.DarkTheme .tooltip.tooltip-top {
  left: 50%;
  transform: translateX(-50%);
  top: -18px;
  box-shadow: 3px 4px 16px 0 rgba(0, 11, 65, 0.15);
  padding: 2px 5px;
}
.DarkTheme .tooltip.tooltip-top:after {
  content: "";
  width: 0;
  height: 0;
  border-left: 5px solid transparent;
  border-right: 5px solid transparent;
  border-top: 5px solid #000000;
  font-size: 0;
  line-height: 0;
  position: absolute;
  bottom: -5px;
  left: calc(50% - 5px);
}
.DarkTheme .tooltip.hidden {
  display: none;
}
.DarkTheme .status {
  border-radius: 54px;
  border: 2px solid rgba(128, 229, 234, 0.5);
  background: rgba(128, 229, 234, 0.2);
  color: var(--foundation-blue-blue-200, #c5f3f5);
  align-items: center;
  display: flex;
  justify-content: center;
  gap: 8px;
  /* Typography/Body/Small/Regular */
  font-family: Inter;
  font-size: 0.8rem;
  font-style: normal;
  font-weight: 400;
  line-height: 120%; /* 14.4px */
  padding: 4px 16px 4px 12px;
}
.DarkTheme .status-inprogress {
  border-radius: 54px;
  border: 2px solid rgba(255, 205, 175, 0.5);
  background: rgba(255, 205, 175, 0.2);
  align-items: center;
  display: flex;
  justify-content: center;
  gap: 8px;
  color: var(--foundation-orange-orange-200, #FFCDAF);
  /* Typography/Body/Small/Regular */
  font-family: Inter;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 120%; /* 14.4px */
  padding: 4px 16px 4px 12px;
}
.DarkTheme .status-done {
  border-radius: 54px;
  border: 2px solid rgba(186, 238, 138, 0.5);
  background: rgba(186, 238, 138, 0.2);
  align-items: center;
  display: flex;
  justify-content: center;
  padding: 4px 16px 4px 12px;
  gap: 8px;
  color: var(--foundation-green-green-200, #BAEE8A);
  /* Typography/Body/Small/Regular */
  font-family: Inter;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 120%; /* 14.4px */
}
.DarkTheme .status-backlog {
  padding: 4px 16px 4px 12px;
  border-radius: 54px;
  border: 2px solid var(--foundation-neutral-dark-theme-neutral-dark-theme-300, #858686);
  background: var(--foundation-neutral-dark-theme-neutral-dark-theme-500, #494B4B);
  align-items: center;
  display: flex;
  justify-content: center;
  color: var(--foundation-neutral-dark-theme-neutral-dark-theme-50, #EDEDED);
  gap: 8px;
  /* Typography/Body/Small/Regular */
  font-family: Inter;
  font-size: 0.8rem;
  font-style: normal;
  font-weight: 400;
  line-height: 120%; /* 14.4px */
}
.DarkTheme .dueto-today {
  display: flex;
  height: 32px;
  padding: 0px 8px 0px 12px;
  align-items: center;
  gap: 4px;
  color: var(--text-white-high-emphasis, #FCFCFE);
  border-radius: 20px;
  background: var(--foundation-orange-orange-500, #FF9251);
  /* Typography/Body/Small/Bold */
  font-family: Inter;
  font-size: 0.8rem;
  font-style: normal;
  font-weight: 600;
  line-height: 120%; /* 14.4px */
}
.DarkTheme .dueto-past {
  border-radius: 20px;
  background: var(--foundation-red-red-500, #FF6969);
  display: flex;
  height: 32px;
  padding: 0px 8px 0px 12px;
  align-items: center;
  gap: 4px;
  color: var(--text-white-high-emphasis, #FCFCFE);
  /* Typography/Body/Small/Bold */
  font-family: Inter;
  font-size: 0.8rem;
  font-style: normal;
  font-weight: 600;
  line-height: 120%; /* 14.4px */
}
.DarkTheme .duto-text {
  color: var(--text-high-emphasis, #090826);
  /* Typography/Body/Small/Regular */
  font-family: Inter;
  font-size: 0.8rem;
  font-style: normal;
  font-weight: 400;
  line-height: 120%; /* 14.4px */
}
.DarkTheme .progressbar {
  color: #E3E9F4;
  background-color: #E3E9F4;
  border-radius: 14px;
}
.DarkTheme .table-text-dark {
  color: var(--text-white-high-emphasis, #FCFCFE);
}
.DarkTheme .task {
  color: var(--text-white-high-emphasis, #FCFCFE);
  /* Typography/Heading 5/Bold */
  font-family: Inter;
  font-size: 24px;
  font-style: normal;
  font-weight: 600;
  line-height: 120%; /* 28.8px */
}
.DarkTheme .z-index-10000 {
  z-index: 10000000;
}
.DarkTheme .custom-input {
  flex: 1 1;
  padding: 10px;
  box-sizing: border-box;
  border: 2px solid #494B4B;
  border-radius: 12px;
}
.DarkTheme .custom-logo-upload:hover {
  background-color: #ededed;
  color: black;
}
.DarkTheme .members {
  color: var(--text-high-emphasis, #090826);
  /* Typography/Body/Large/Regular */
  font-size: 0.7rem;
  font-style: normal;
  font-weight: 400;
  line-height: 120%;
  text-align: left;
  border-bottom: 1px solid #E3E9F4;
}
.DarkTheme .memberscard {
  position: absolute;
  /* bottom: 0; */
  top: 32px;
  left: -115px;
  right: 0;
  z-index: 1000;
  width: 300px;
  border-radius: 14px;
  border: 1px solid var(--foundation-neutral-neutral-400, #E3E9F4);
  background: #FFF;
  box-shadow: 10px 14px 74px 0px var(--primary-opactiy-10);
}
.DarkTheme .permissions-tab {
  min-width: 615px;
  overflow: scroll;
}
.DarkTheme .permission-badge {
  background-color: #EFF3F9;
  color: black;
  padding: 8px;
  width: 315px;
  border-radius: 15px;
  height: 37px;
}
.DarkTheme .permission-text {
  font-size: 11px;
  font-weight: 500;
}
.DarkTheme .team-label-img {
  height: 40px;
  min-width: 40px;
}
.DarkTheme .team-label-heading {
  color: white;
  font-family: Inter;
  text-align: left;
  font-size: 0.6rem;
  font-style: normal;
  font-weight: 600;
  line-height: 120%;
}
.DarkTheme .project-info {
  margin-left: 360px;
}
.DarkTheme .permission-info {
  width: 80px;
  background-color: #F0FBE6;
  padding: 8px;
  border-radius: 15px;
  height: 37px;
}
.DarkTheme .permission-rejected {
  width: 80px;
  background-color: #FFF0F0;
  padding: 8px;
  border-radius: 15px;
  height: 37px;
}
.DarkTheme .permission-table {
  height: 15px;
  min-width: 16px;
  margin-left: 22px;
  margin-top: 2px;
}
.DarkTheme .permission-warning {
  height: 10px;
  min-width: 12px;
  margin-top: -3px;
  margin-left: 15px;
}
.DarkTheme .permission-approval {
  position: absolute;
  z-index: 1000;
  width: 275px;
  border-radius: 14px;
  border: 1px solid var(--foundation-neutral-neutral-400, #E3E9F4);
  background: #FFF;
}
.DarkTheme .team-mate-accordion {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-repeat: no-repeat;
  background-position: 12px 14px;
  min-width: 394px;
  flex: 1 1;
  padding: 9px;
  box-sizing: border-box;
  border: 1px solid #ccc;
  border-radius: 10px;
  margin-right: 12px;
  padding-left: 36px;
}
.DarkTheme .members-count {
  font-size: 11px;
  font-weight: 500;
  margin: 2px;
  margin-right: 9px;
}
.DarkTheme .accordion-btn {
  padding: 14px 20px;
  background-color: #343535;
  color: white;
  border-bottom: 2px solid #E3E9F4;
  cursor: pointer;
  margin-right: 10px;
  width: 599px;
  text-align: left;
  justify-content: space-between;
}
.DarkTheme .accordion-label {
  font-weight: 700;
  font-size: 13px;
  margin: 7px;
}
.DarkTheme .accordion-content {
  font-size: 20px;
  margin-top: 20px;
}
.DarkTheme .accordion-btn:hover {
  background-color: #EFF3F9;
  border-bottom: 2px solid #E3E9F4;
}
.DarkTheme .accordion-btn:active {
  border: none;
}
.DarkTheme .accordion-btn:focus {
  border: none;
}
.DarkTheme .notification {
  z-index: 9999999999;
  box-shadow: 10px 14px 74px 0px rgba(92, 96, 101, 0.2);
  width: 400px;
  position: fixed;
  bottom: 20px;
  left: 20px;
  background-color: #343535;
  color: white;
  padding: 0px 0px;
  border-radius: 14px;
  transition: transform 0.3s ease-in-out, opacity 0.3s ease-in-out;
}
.DarkTheme .notification-message {
  color: white;
  font-weight: 600;
  font-size: 14px;
  margin-bottom: 5px;
  padding: 5px;
  border-radius: 5px;
}
.DarkTheme .msg-container {
  padding: 20px 20px;
}
.DarkTheme .notification-icon {
  display: flex;
  border-bottom-left-radius: 14px;
  border-top-left-radius: 14px;
  width: 95px;
  align-items: center;
  justify-content: center;
}
.DarkTheme .notification.show {
  transform: translateX(0);
  opacity: 1;
}
.DarkTheme .overlay .border-right {
  border-right: 1px solid #E3E9F4;
}
.DarkTheme .overlay .title {
  overflow: hidden;
  color: var(--text-high-emphasis, #090826);
  text-overflow: ellipsis;
  /* Typography/Heading 3/Bold */
  font-family: Inter;
  font-size: 1.8rem;
  font-style: normal;
  font-weight: 600;
  line-height: 120%; /* 42px */
}
.DarkTheme .overlay {
  position: fixed;
  top: 0;
  z-index: 2000000000000 !important;
  bottom: 0;
  left: 0;
  right: 0;
  background: var(--foundation-neutral-neutral-900, rgba(92, 96, 101, 0.7568627451));
  width: 100vw;
  /* height: 100vh; */
  display: flex;
  align-items: center;
  justify-content: center;
}
.DarkTheme .overlay .taskPopUp, .DarkTheme .overlay .memberPopup, .DarkTheme .overlay .modalPopup {
  background: var(--foundation-neutral-dark-theme-neutral-dark-theme-700, #343535);
  /* modal page */
  box-shadow: 10px 14px 114px 0px rgba(31, 32, 32, 0.4);
  max-height: 95vh;
  min-width: auto;
}
.DarkTheme .overlay .taskPopUp.h-auto, .DarkTheme .overlay .memberPopup.h-auto, .DarkTheme .overlay .modalPopup.h-auto {
  height: auto !important;
  min-height: auto;
}
.DarkTheme .overlay .taskPopUp .scrollable, .DarkTheme .overlay .memberPopup .scrollable, .DarkTheme .overlay .modalPopup .scrollable {
  max-height: 65vh;
  overflow-y: auto;
  scroll-behavior: smooth;
}
.DarkTheme .overlay .taskPopUp .title, .DarkTheme .overlay .memberPopup .title, .DarkTheme .overlay .modalPopup .title {
  overflow: hidden;
  color: white;
  text-overflow: ellipsis;
  /* org */
  /* Typography/Heading 3/Bold */
  font-family: Inter;
  font-size: 1.8rem;
  font-style: normal;
  font-weight: 600;
  line-height: 120%; /* 42px */
}
.DarkTheme .overlay .taskPopUp .title .orgCreate, .DarkTheme .overlay .memberPopup .title .orgCreate, .DarkTheme .overlay .modalPopup .title .orgCreate {
  border-radius: 24px;
  background: var(--foundation-neutral-dark-theme-neutral-dark-theme-700, #343535);
  /* modal page */
  box-shadow: 10px 14px 114px 0px rgba(31, 32, 32, 0.4);
  min-height: 80vh;
  min-width: auto;
  height: 50vh !important;
  overflow-x: hidden;
}
.DarkTheme .overlay .taskPopUp .title-text-small-color, .DarkTheme .overlay .memberPopup .title-text-small-color, .DarkTheme .overlay .modalPopup .title-text-small-color {
  color: white;
}
.DarkTheme .overlay .border-right {
  border-right: 1px solid #E3E9F4;
}
.DarkTheme .overlay .play-pause {
  background: var(--foundation-secondary-secondary-800, var(--secondary-500));
}
.DarkTheme .overlay .play-pause-button {
  border-radius: 50px;
  background: var(--foundation-secondary-secondary-500, var(--secondary-700));
  box-shadow: 0px 4px 8px 0px rgba(92, 96, 101, 0.06);
}
.DarkTheme .overlay .sum-title {
  color: white;
  /* Typography/Body/Large/Bold */
  font-family: Inter;
  font-size: 0.9rem;
  font-style: normal;
  font-weight: 500;
  line-height: 120%; /* 19.2px */
}
.DarkTheme .overlay .uploadedFile {
  border-radius: 14px;
  border: 2px solid var(--foundation-neutral-dark-theme-neutral-dark-theme-500, #494B4B);
  background: var(--foundation-neutral-dark-theme-neutral-dark-theme-500, #494B4B);
  position: relative;
  /* card */
  box-shadow: 10px 14px 14px 0px rgba(92, 96, 101, 0.08);
}
.DarkTheme .overlay .uploadedFile > button {
  position: absolute;
  top: -10px;
  right: 0;
  border: 2px solid var(--foundation-neutral-neutral-400, #E3E9F4);
  background-color: var(--foundation-neutral-neutral-50, #FCFCFE);
  border-radius: 50%;
  width: 16px;
  height: 16px;
  line-height: 12px;
}
.DarkTheme .overlay .uploadedFile > button > i {
  font-size: 0.7em;
  line-height: 12px;
}
.DarkTheme .overlay .uploadedFile .filename {
  color: white;
  /* Typography/Body/Default/Regular */
  font-family: Inter;
  font-size: 0.8rem;
  font-style: normal;
  font-weight: 400;
  line-height: 130%; /* 18.2px */
}
.DarkTheme .overlay .uploadedFile .icon-color {
  color: var(--text-white-medium-emphasis, rgba(252, 252, 254, 0.6));
}
.DarkTheme .overlay .uploadedFile .input-custom {
  border-radius: 14px;
  border: 2px solid var(--foundation-neutral-dark-theme-neutral-dark-theme-400, #6D6F6F);
  color: white;
  background-color: #6D6F6F;
}
.DarkTheme .overlay .uploadedFile input::placeholder, .DarkTheme .overlay .uploadedFile textarea::placeholder {
  opacity: 1;
  color: #9ca3af;
  background: aliceblue;
}
.DarkTheme .overlay .uploadedFile textarea::placeholder {
  color: white;
  background-color: #6D6F6F !important;
}
.DarkTheme .overlay .uploadedFile .input-custom::placeholder {
  color: white;
  background-color: #6D6F6F !important;
}
.DarkTheme .overlay .uploadedFile .fileDetail {
  color: white;
  /* Typography/Body/Extra Small/Regular */
  font-family: Inter;
  font-size: 10px;
  font-style: normal;
  font-weight: 400;
  line-height: 120%; /* 12px */
}
.DarkTheme .overlay .uploadedFile .document-svg {
  box-shadow: 2px 4px 10px 0px rgba(92, 96, 101, 0.24);
}
.DarkTheme .overlay .uploadedFile .pdf {
  border-radius: 1px;
  background: var(--foundation-red-red-500, #FF6969);
  color: #FFF;
  text-align: center;
  font-family: Inter;
  font-size: 8px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
}
.DarkTheme .overlay .uploadedFile .default {
  border-radius: 1px;
  background: var(--foundation-red-red-500, #48792f);
  color: #FFF;
  text-align: center;
  font-family: Inter;
  font-size: 8px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
}
.DarkTheme .overlay .uploadedFile .png {
  border-radius: 1px;
  background: var(--foundation-dark-blue-dark-blue-500, #6C9BF6);
  color: #FFF;
  text-align: center;
  font-family: Inter;
  font-size: 8px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
}
.DarkTheme .overlay .uploadedFile .svg {
  border-radius: 1px;
  background: var(--foundation-red-red-500, #f09409);
  color: #FFF;
  text-align: center;
  font-family: Inter;
  font-size: 8px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
}
.DarkTheme .alert {
  height: auto;
  align-items: flex-end;
  left: -175px;
}
.DarkTheme .popup {
  border-radius: 8px;
  background: var(--foundation-neutral-dark-theme-neutral-dark-theme-500, #494B4B);
  /* popover - dark theme */
  box-shadow: 10px 14px 114px 0px rgba(31, 32, 32, 0.4);
  /* card */
  box-shadow: 10px 14px 14px 0px rgba(92, 96, 101, 0.08);
}
.DarkTheme .popup .description-txt {
  border-radius: 14px;
  border: 1px solid var(--foundation-neutral-neutral-400, #E3E9F4);
}
.DarkTheme .popup .link-txt {
  border-radius: 14px;
  border: 1px solid var(--foundation-neutral-neutral-400, #E3E9F4);
}
.DarkTheme .btn-popup {
  border: 2px solid var(--primary);
  background: var(--foundation-secondary-secondary-400, var(--primary));
  box-shadow: 0px 5px 5px 0px var(--primary-opactiy-40);
  color: black;
  font-weight: 600;
}
.DarkTheme .btn-popup:hover {
  background: var(--secondary-300);
  border: 2px solid var(--secondary-300);
}
.DarkTheme .bg-btn-teal {
  background: var(--foundation-secondary-secondary-500, var(--secondary-700));
}
.DarkTheme .border-btn-select {
  border: 2px solid rgba(9, 8, 38, 0.6);
}
.DarkTheme .sidebar-data-todo {
  border-radius: 14px;
  background: var(--foundation-neutral-dark-theme-neutral-dark-theme-500, #494B4B);
}
.DarkTheme .sidebar-txt {
  margin-top: 5px;
  color: white;
  font-family: Inter;
  font-size: 0.8rem;
  font-style: normal;
  font-weight: 400;
  line-height: 130%;
}
.DarkTheme .task-tab {
  border-radius: 14px;
  background: var(--primary-opactiy-20);
  color: var(--secondary-200);
  /* Typography/Body/Default/Bold */
  font-family: Inter;
  font-style: normal;
  font-weight: 600;
  line-height: 120%; /* 16.8px */
}
.DarkTheme .comment-box {
  border-radius: 14px;
  border: 2px solid var(--foundation-neutral-dark-theme-neutral-dark-theme-500, #494B4B);
}
.DarkTheme .todo-hover:hover {
  border-radius: 14px;
  background: var(--foundation-neutral-neutral-400, #E3E9F4);
}
.DarkTheme .dropdown-task {
  border-radius: 14px;
  border: 2px solid var(--foundation-neutral-dark-theme-neutral-dark-theme-400, #6D6F6F);
  background: transparent;
  color: var(--text-white-high-emphasis, #FCFCFE);
  /* Typography/Body/Default/Regular */
  font-family: Inter;
}
.DarkTheme .progress-estimated {
  font-size: 10px;
  color: var(--text-white-medium-emphasis, rgba(252, 252, 254, 0.6));
}
.DarkTheme .active-status {
  border-radius: 54px;
  border: 2px solid rgba(186, 238, 138, 0.5);
  background: rgba(186, 238, 138, 0.2);
  color: var(--foundation-green-green-200, #BAEE8A);
  /* Typography/Body/Small/Regular */
  font-family: Inter;
  font-size: 0.8rem;
  font-style: normal;
  font-weight: 400;
  line-height: 120%; /* 14.4px */
}
.DarkTheme .unactive-status {
  border-radius: 54px;
  border: 2px solid rgba(255, 64, 64, 0.5);
  background: rgba(255, 105, 105, 0.2);
  color: var(--foundation-red-red-200, #FF9B9B);
  /* Typography/Body/Small/Regular */
  font-family: Inter;
  font-size: 0.8rem;
  font-style: normal;
  font-weight: 400;
  line-height: 120%; /* 14.4px */
}
.DarkTheme .dropdown-custom {
  background-color: #6D6F6F;
}
.DarkTheme .member-section-title {
  color: white;
  /* Typography/Body/Default/Bold */
  font-family: Inter;
  font-size: 14px;
  font-style: normal;
  font-weight: 600;
  line-height: 120%; /* 16.8px */
}
.DarkTheme .dropdown-container {
  border-radius: 15px !important;
  border: transparent !important;
  box-shadow: none !important;
  border: 2px solid var(--main-neutral-dark-theme-neutral-dark-theme-400, #6D6F6F) !important;
  background: var(--main-neutral-dark-theme-neutral-dark-theme-700, #343535) !important;
}
.DarkTheme .dropdown-container:focus-within {
  border: transparent !important;
  box-shadow: none !important;
  border: 2px solid var(--main-neutral-dark-theme-neutral-dark-theme-400, #6D6F6F) !important;
  background: var(--main-neutral-dark-theme-neutral-dark-theme-500, #494B4B);
}
.DarkTheme .dropdown-custom {
  background: var(--main-neutral-dark-theme-neutral-dark-theme-500, #494B4B) !important;
  /* popover */
  box-shadow: 10px 14px 74px 0px rgba(92, 96, 101, 0.2);
  z-index: 100000 !important;
  display: block;
}
.DarkTheme .rmsc .gray {
  color: #9ca3af !important;
}
.DarkTheme .dropdown-menu {
  position: absolute;
  z-index: 100000000000000 !important;
  border-radius: 8px;
  border: 2px solid var(--main-neutral-dark-theme-neutral-dark-theme-400, #6D6F6F);
  background: var(--main-neutral-dark-theme-neutral-dark-theme-500, #494B4B);
  /* popover - dark theme */
  box-shadow: 10px 14px 114px 0px rgba(31, 32, 32, 0.4);
}
.DarkTheme .dropdown, .DarkTheme .btn-simple {
  border-radius: 14px;
  border: 2px solid var(--main-neutral-dark-theme-neutral-dark-theme-400, #6D6F6F);
}
.DarkTheme .dropdown-options:hover, .DarkTheme .dropdown-content {
  background-color: var(--main-neutral-dark-theme-neutral-dark-theme-700, #343535) !important;
  color: #fff !important;
}
.DarkTheme .panel-content {
  background-color: var(--main-neutral-dark-theme-neutral-dark-theme-700, #343535) !important;
  width: 215px !important;
}
.DarkTheme .rmsc .select-item:hover {
  background: rgba(89, 221, 211, 0.2);
}
.DarkTheme .rmsc .select-item.selected {
  background: rgba(89, 221, 211, 0.2);
}
.DarkTheme .rmsc .search input {
  background: var(--main-neutral-dark-theme-neutral-dark-theme-700, #343535) !important;
  color: white !important;
}
.DarkTheme .invite-link {
  color: #9ca3af;
  /* Typography/Body/Default/Bold */
  font-family: Inter;
  font-size: 14px;
  font-style: normal;
  font-weight: 600;
  line-height: 120%; /* 16.8px */
}
.DarkTheme .btn-green {
  background: var(--main-secondary-secondary-400, var(--primary));
  color: #090826;
  border-radius: 14px;
}
.DarkTheme .navtab-active {
  border-radius: 14px;
  background: var(--main-secondary-secondary-50, var(--secondary-200));
  color: var(--main-secondary-secondary-800, var(--secondary-500));
  /* Typography/Body/Default/Bold */
  font-family: Inter;
  font-size: 14px;
  font-style: normal;
  font-weight: 600;
  line-height: 120%; /* 16.8px */
}
.DarkTheme .navtab-unactive {
  color: white;
  /* Typography/Body/Default/Bold */
  font-family: Inter;
  font-size: 14px;
  font-style: normal;
  font-weight: 600;
  line-height: 120%; /* 16.8px */
}
.DarkTheme .PhoneInputInput {
  background: var(--main-neutral-dark-theme-neutral-dark-theme-700, #343535) !important;
}
.DarkTheme .txt-green {
  color: var(--main-secondary-secondary-400, var(--primary));
}
.DarkTheme .multi-dropdown {
  background: var(--main-neutral-dark-theme-neutral-dark-theme-500, #494B4B) !important;
  box-shadow: 10px 14px 74px 0px rgba(92, 96, 101, 0.2);
  border-radius: 14px;
}
.DarkTheme .btn-red {
  background: var(--main-red-red-500, #FF6969);
  box-shadow: 0px 10px 31px 0px rgba(255, 105, 105, 0.4);
}
.DarkTheme .multiselect-wrapper {
  position: relative;
  color: black;
}
.DarkTheme .pill-container {
  position: absolute;
  top: 0;
  left: 0;
  width: calc(100% - 30px);
  padding: 3px;
  box-sizing: border-box;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
}
.DarkTheme .pill {
  background-color: #e0e0e0;
  padding: 5px 10px;
  margin: 5px;
  border-radius: 20px;
}
.DarkTheme .form-steps-active {
  background-color: #C8CFDB;
  height: 40px;
  width: 40px;
  box-shadow: 0 0 0 3px #343535 inset;
  box-sizing: border-box;
  border: 2.5px solid #C8CFDB;
}
.DarkTheme .form-steps-complete {
  background-color: var(--primary);
  height: 35px;
  width: 35px;
  box-sizing: border-box;
}
.DarkTheme .divider {
  background: var(--primary);
}
.DarkTheme .form-steps {
  background-color: #C8CFDB;
  height: 40px;
  width: 40px;
  box-shadow: 0 0 0 3px #343535 inset;
  box-sizing: border-box;
}
.DarkTheme .rmsc .dropdown-container {
  width: 215px;
  height: 39px;
  box-sizing: border-box;
  border: 2px solid #494B4B !important;
  border-radius: 12px !important;
  font-weight: 500;
}
.DarkTheme .check-icon {
  height: 11px;
}
.DarkTheme .error-text {
  font-size: 12px;
  color: var(--red-300);
  width: 0px !important;
}
.DarkTheme .cancel-btn-popup {
  color: black;
  border: 2px solid #E3E9F4;
  background: var(--foundation-secondary-secondary-400, #fff);
  border-radius: 11px;
  margin-right: 5px;
  font-weight: 600;
}
.DarkTheme .cancel-btn-popup:hover {
  background: #ededed;
}
.DarkTheme input[type=file] {
  display: none;
}
.DarkTheme .custom-file-upload {
  border: 2px solid #494B4B;
  display: inline-block;
  padding: 8px 18px;
  cursor: pointer;
  border-radius: 10px;
  font-weight: 600;
}
.DarkTheme .spacing-div {
  margin-left: 12rem;
}
.DarkTheme .modalPopup .spacing-div {
  margin-left: auto;
}
.DarkTheme .spacing-div-sm {
  margin-left: 18rem;
}
.DarkTheme input[type=checkbox] {
  width: 18px !important;
  height: 18px !important;
  margin-right: 10px;
  margin-top: 5px;
  -o-appearance: none;
  appearance: none;
  box-shadow: none;
  font-size: 0.8em;
  text-align: center;
  line-height: 1.2em;
  background: var(--foundation-neutral-neutral-100, #F4F7FB);
  border: 2px solid white;
}
.DarkTheme input[type=checkbox]:checked:after {
  height: 20px !important;
  content: "🗸";
  padding: 2px;
  font-weight: 600;
  font-size: 1rem;
  color: white;
  background: var(--primary);
  border: 2px solid var(--secondary-700);
  border-radius: 1px;
}
.DarkTheme .edit-user {
  background: var(--main-neutral-dark-theme-neutral-dark-theme-700, #343535) !important;
  height: -moz-fit-content;
  height: fit-content;
  width: 595px;
}
.DarkTheme .input-field {
  width: 250px;
}
.DarkTheme .toggle-bg {
  position: relative;
  display: inline-block;
  width: 180px;
  height: 31px;
  color: black;
}
.DarkTheme .toggle-slider {
  position: absolute;
  content: "";
  height: 31px;
  width: 95px;
  left: -17px;
  top: 0px;
  background-color: #9CA2AB;
  transition: 0.4s;
}
.DarkTheme .teamInfoPopup {
  background: #343535;
  height: -moz-fit-content;
  height: fit-content;
  width: 1050px;
}
.DarkTheme .teamInfoGrid {
  gap: 34rem;
}
.DarkTheme .vl {
  border-left: 1px solid #ccc;
  margin-top: -94px;
}
.DarkTheme .small-text {
  font-size: 8px;
}
.DarkTheme .badge-text {
  font-size: 11px;
  color: black;
}
.DarkTheme .team-name {
  min-width: 630px;
  flex: 1 1;
  padding: 10px;
  box-sizing: border-box;
  border: 1px solid #ccc;
  border-radius: 5px;
}
.DarkTheme .teamInfoSidebar {
  margin-left: 50px;
}
.DarkTheme .info-badge {
  background-color: #EFF3F9;
  padding: 5px;
  width: 185px;
  border-radius: 15px;
}
.DarkTheme .badge-icon {
  margin: 12px;
  color: black;
}
.DarkTheme .popup-text {
  font-weight: 500;
  font-size: 13px;
}
.DarkTheme .date-text {
  font-size: 11px;
}
.DarkTheme .profile-cover {
  width: 145px;
  height: 145px;
  margin: 15px;
}
.DarkTheme .img-div {
  border-left: 1px solid #ccc;
}
.DarkTheme .team-label {
  height: 480px;
}
.DarkTheme select:invalid {
  color: rgba(255, 255, 255, 0.35);
}
.DarkTheme select option {
  background-color: var(--foundation-neutral-dark-theme-neutral-dark-theme-600, #424444);
  color: var(--text-white-medium-emphasis, rgba(252, 252, 254, 0.6));
}
.DarkTheme .team-mate {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-repeat: no-repeat;
  background-position: 9px 14px;
  min-width: 470px;
  flex: 1 1;
  padding: 10px;
  box-sizing: border-box;
  border: 1px solid #ccc;
  border-radius: 10px;
  margin-right: 12px;
  padding-left: 29px;
}
.DarkTheme .team-mate::placeholder {
  color: rgba(9, 8, 38, 0.3215686275);
  font-size: 13px;
}
.DarkTheme .switch {
  position: relative;
  display: inline-block;
  width: 35px;
  height: 12px;
}
.DarkTheme .switch input {
  opacity: 0;
  width: 0;
  height: 0;
}
.DarkTheme .slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #E3E9F4;
  transition: 0.4s;
}
.DarkTheme .slider:before {
  position: absolute;
  content: "";
  height: 16px;
  width: 16px;
  left: 1px;
  top: -2px;
  background-color: #9CA2AB;
  transition: 0.4s;
}
.DarkTheme input:checked + .slider {
  background-color: #E3E9F4;
}
.DarkTheme input:focus + .slider {
  box-shadow: 0 0 1px var(--secondary-200);
}
.DarkTheme input:checked + .slider:before {
  transform: translateX(17px);
  background-color: var(--secondary-700);
}
.DarkTheme .role-info {
  width: 420px;
}
.DarkTheme .permission-page {
  overflow: scroll;
  height: 43vh;
}
.DarkTheme .value-text {
  color: #DCE4F1;
  font-size: 0.8rem;
  font-style: normal;
  font-weight: 600;
  line-height: 60%;
}
.DarkTheme .info-box {
  padding-left: 15px;
  padding-right: 15px;
  border-left: 3px solid #DCE4F1;
}
.DarkTheme .permission-type {
  color: white;
}
.DarkTheme .value-header {
  color: #DCE4F1;
}
.DarkTheme .switch {
  position: relative;
  display: inline-block;
  width: 35px;
  height: 12px;
}
.DarkTheme .switch input {
  opacity: 0;
  width: 0;
  height: 0;
}
.DarkTheme .slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #E3E9F4;
  transition: 0.4s;
}
.DarkTheme .slider:before {
  position: absolute;
  content: "";
  height: 31px;
  width: 95px;
  left: 0px;
  top: 0px;
  background-color: #88E133;
  transition: 0.4s;
}
.DarkTheme .toggle-btn-text {
  position: absolute;
  top: 6px;
  margin-left: 17px;
  font-weight: 500;
}
.DarkTheme .toggle-btn-dis-text {
  position: absolute;
  top: 6px;
  margin-left: 104px;
  font-weight: 500;
}
.DarkTheme input:checked + .slider {
  background-color: #E3E9F4;
}
.DarkTheme input:focus + .slider {
  box-shadow: 0 0 1px var(--secondary-200);
}
.DarkTheme input:checked + .slider:before {
  transform: translateX(85px);
  background-color: #FF8787;
}
.DarkTheme .slider.round {
  border-radius: 34px;
}
.DarkTheme .slider.round:before {
  border-radius: 15px;
}
.DarkTheme .toggle-checkbox {
  display: none;
  visibility: hidden !important;
}
.DarkTheme .team-mates-scroll {
  overflow-y: scroll;
  height: 470px;
}
.DarkTheme .team-leads-scroll {
  overflow-y: scroll;
  height: 330px;
}
.DarkTheme ::-webkit-scrollbar {
  width: 6px;
}
.DarkTheme ::-webkit-scrollbar-track {
  background: #343535;
}
.DarkTheme ::-webkit-scrollbar-thumb {
  background: #494B4B;
  border-radius: 20px;
}
.DarkTheme ::-webkit-scrollbar-thumb:hover {
  background: #494B4B;
}
.DarkTheme .info-icon, .DarkTheme .info-icon:hover, .DarkTheme .info-icon:focus {
  font-weight: normal;
  border: 1px solid var(--primary);
  font-style: italic;
  color: #ffffff;
  display: inline-block;
  font-size: 10px;
  width: 15px;
  height: 15px;
  line-height: 13px;
  text-align: center;
  border-radius: 50%;
  background-color: transparent;
  padding: 0;
  vertical-align: middle;
}
.DarkTheme form label {
  color: inherit;
}
.DarkTheme .tooltip, .DarkTheme .tooltip-inner {
  color: #ffffff !important;
}
.DarkTheme .custom-logo-upload {
  border: 2px solid #E3E9F4;
  display: inline-block;
  padding: 8px 28px;
  cursor: pointer;
  border-radius: 10px;
  font-weight: 600;
  width: 150px;
  margin-top: 5px;
}
.DarkTheme .red-btn {
  border-radius: 9px;
  border: 2px solid rgba(255, 255, 255, 0.8);
  background: #FF6969;
  color: var(--text-high-emphasis, #090826);
  font-family: Inter;
  font-size: 0.82rem;
  font-style: normal;
  font-weight: 600;
  line-height: 143%;
}
.DarkTheme .red-btn:hover {
  background: #ff9c9c;
  border: 2px solid #ff9c9c;
}
.DarkTheme .btn-create {
  width: 30px;
  height: 30px;
  text-align: center;
  line-height: 30px;
  border-radius: 100%;
}
.DarkTheme .btn-more-options i, .DarkTheme .btn-create i {
  color: white;
}
.DarkTheme div:has(> .more-options-wrapper) {
  overflow: unset !important;
}
.DarkTheme .more-options-wrapper {
  position: relative;
  overflow: unset !important;
}
.DarkTheme .more-options-wrapper .btn-more-options {
  width: 30px;
  height: 30px;
  text-align: center;
  line-height: 30px;
  border-radius: 100%;
}
.DarkTheme .more-options-wrapper .btn-more-options:hover, .DarkTheme .btn-create:hover {
  background-color: #343535;
}
.DarkTheme .more-options-wrapper .more-options {
  position: absolute;
  right: 0;
  top: 22px;
  background-color: #343535;
  border: 1px solid #232323;
  z-index: 9;
  padding: 13px 15px;
  text-align: center;
  border-radius: 14px;
  box-shadow: 10px 14px 74px 0px rgba(0, 0, 0, 0.5);
}
.DarkTheme .items-row:last-of-type .more-options-wrapper .more-options {
  bottom: 22px;
  top: auto;
}
.DarkTheme .more-options-wrapper .more-options > button {
  display: flex;
  align-items: center;
}
.DarkTheme .more-options-wrapper .more-options > button:disabled {
  color: #bbbbbb;
}
.DarkTheme .more-options-wrapper .more-options > button:not(:last-child) {
  margin-bottom: 15px;
}
.DarkTheme .more-options-wrapper .more-options > button span {
  min-width: max-content;
  margin-left: 10px;
  padding: 4px 25px;
}
.DarkTheme .more-options-wrapper .more-options > button span:hover {
  background-color: var(--foundation-neutral-dark-theme-neutral-dark-theme-600, #424444);
  padding: 4px 25px;
  border-radius: 13px;
}
.DarkTheme button.btn-remove {
  background-color: #232323;
}

#root:has(.DarkTheme) ~ .tooltip.show {
  background-color: #000000;
  color: #ffffff;
  box-shadow: -3px 4px 16px 0 rgba(0, 0, 0, 0.5);
  position: relative;
  z-index: 9999999999;
}

#root:has(.DarkTheme) ~ .tooltip.show:after {
  border-right-color: #000000;
}

.Navheader-collapse > div {
  background-color: --foundation-neutral-dark-theme-neutral-dark-theme-500, #494B4B;
}

.org-selector.pb-3:after {
  content: "";
  display: block;
  width: calc(100% - 30px);
  height: 15px;
  margin: 0 15px;
  border-bottom: 2px solid rgba(109, 111, 111, 0.6352941176);
}`, "",{"version":3,"sources":["webpack://./src/AppDark.scss"],"names":[],"mappings":"AAAA,gBAAgB;AAAhB;EAmzBI,8BAAA;EAMA,iCAAA;EA0iDF,oBAAA;EAwBD,UAAA;EAKC,UAAA;EAKA,WAAA;EAMA,oBAAA;EAyCD,yBAAA;AA16ED;AATI;EACI,sBAAA;AAWR;AATI;EACI,6BAAA;EACA,gBAAA;EACA,kBAAA;EACA,SAAA;EACF,UAAA;EACA,gFAAA;EACD,iBAAA;EACA,gCAAA;EACA,iBAAA;AAWL;AARI;EACI,kBAAA;EACA,mBAAA;EACA,kBAAA;EAEA,mBAAA;AASR;AALI;EACI,iBAAA;EACA,gFAAA;EACA,iCAAA;EACA,mBAAA;EAEA,kBAAA;EACA,mBAAA;EACA,gBAAA;AAOR;AALI;EACI,YAAA;AAOR;AALI;EACI,gFAAA;EACA,YAAA;EAEA,mBAAA;AAMR;AAHK;EAAgD,gFAAA;EAAkF,+CAAA;AAOvI;AALK;EAAkB,gFAAA;EAAkF,+CAAA;AASzG;AAPK;EACG,2BAAA;AASR;AAPI;EACI,2DAAA;AASR;AANI;EACI,4BAAA;EACA,6BAAA;AAQR;AALI;EACI,8BAAA;EAEA,2BAAA;EACA,mBAAA;AAOR;AAJI;EACI,gBAAA;EACA,2BAAA;EACA,oBAAA;EACA,kBAAA;EACA,gFAAA;AAMR;AAFK;EACG,2FAAA;EAA6F,+CAAA;AAKrG;AAHI;EACI,gFAAA;EAAkF,+CAAA;AAM1F;AAJI;EACI,gFAAA;EAAkF,+CAAA;EAClF,8BAAA;AAOR;AANQ;EAAmE,+CAAA;AAS3E;AANK;EACG,2BAAA;AAQR;AANK;EACG,2FAAA;AAQR;AANI;EACG,qBAAA;EACD,YAAA;AAQN;AALI;EACI,+CAAA;EACA,mBAAA;EACA,kBAAA;EACA,iBAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,iBAAA;EACA,mBAAA;EACA,iBAAA;AAOR;AAJI;EACI,+CAAA;EACA,mBAAA;EACA,kBAAA;EACA,iBAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;AAMR;AAFI;EACI,YAAA;EACA,0BAAA;EACA,mBAAA;EACJ,iCAAA;EACA,kBAAA;EACA,iBAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA,EAAA,WAAA;EACA,cAAA;AAIJ;AAFI;EACI,0BAAA;EACA,YAAA;EACA,gBAAA;AAIR;AAFI;EACI,0DAAA;AAIR;AAEK;EACG,+CAAA;EAEA,mBAAA;EACJ,iCAAA;EACA,kBAAA;EACA,iBAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA,EAAA,WAAA;AADJ;AAGI;EACI,0BAAA;EACA,YAAA;EACA,gBAAA;AADR;AAMI;EACI,YAAA;EAEA,kBAAA;EACC,mHAAA;AALT;AAQK;EAEI,YAAA;EACA,iBAAA;EACA,mHAAA;AAPT;AASK;EACI,+CAAA;EAEA,8BAAA;EAEA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA,EAAA,WAAA;AATT;AAWK;EAEA,0CAAA;EACA,qEAAA;EACA,uDAAA;EACA,cAAA;EAEA,iCAAA;EACA,kBAAA;EACA,iBAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA,EAAA,WAAA;AAXL;AAcK;EACG,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,gCAAA;AAZR;AAcQ;EACI,iBAAA;EACJ,gCAAA;EAEI,aAAA;EACJ,mBAAA;EACA,yBAAA;AAbR;AAeO;EACC,kEAAA;AAbR;AAeQ;EACI,cAAA;AAbZ;AAeQ;EACI,+CAAA;AAbZ;AAgBQ;EACI,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,8BAAA;AAdZ;AAgBQ;EACI,iBAAA;EACA,aAAA;EACA,mBAAA;EACA,8BAAA;AAdZ;AAgBQ;EACA,gEAAA;AAdR;AAgBQ;EACG,kEAAA;EACC,eAAA;AAdZ;AAiBQ;EACI,+CAAA;EAEJ,8BAAA;EAEA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA,EAAA,WAAA;AAjBR;AAmBQ;EACI,kEAAA;EAEJ,oCAAA;EACA,kBAAA;EACA,iBAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA,EAAA,WAAA;AAlBR;AAoBQ;EACI,sFAAA;AAlBZ;AAoBQ;EACI,+CAAA;AAlBZ;AAoBQ;EACI,mBAAA;EACA,gCAAA;EACA,qEAAA;EACA,yCAAA;EACA,kBAAA;EACA,iBAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;AAlBZ;AAqBQ;EACI,sDAAA;EACA,sDAAA;EACA,gBAAA;AAnBZ;AAqBQ;EACI,gCAAA;AAnBZ;AAsBQ;EACI,kBAAA;EACA,cAAA;EACA,SAAA;EACD,QAAA;EACC,aAAA;EACA,YAAA;EAEA,mBAAA;EACJ,gEAAA;EACA,gBAAA;EAEA,YAAA;EACA,qDAAA;AAtBR;AAyBQ;EACI,0DAAA;AAvBZ;AAyBQ;EACI,yCAAA;EAEJ,kCAAA;EACA,iBAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,gBAAA;EACA,kBAAA;AAxBR;AA0BQ;EACI,6BAAA;AAxBZ;AA2BQ;EACI,mBAAA;EACA,0DAAA;AAzBZ;AA2BQ;EACI,gEAAA;EACA,YAAA;EACJ,eAAA;AAzBR;AA2BQ;EAEI,YAAA;EACJ,8BAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA,EAAA,SAAA;AA1BR;AA4BQ;EACI,uDAAA;EACJ,gBAAA;EACA,oCAAA;EACA,kBAAA;EACA,iBAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA,EAAA,WAAA;AA1BR;AA4BQ;EACI,aAAA;AA1BZ;AA4BQ;EAGA,iCAAA;EACA,kBAAA;EACA,iBAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA,EAAA,WAAA;AA5BR;AA8BQ;EAGA,oCAAA;EACA,kBAAA;EACA,iBAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA,EAAA,WAAA;AA9BR;AAgCQ;EACI,6BAAA;EAIA,oCAAA;EACA,kBAAA;EACA,iBAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA,EAAA,WAAA;AAjCZ;AAmCQ;EACI,mBAAA;EACA,0DAAA;AAjCZ;AAmCQ;EACI,aAAA;EACA,sBAAA;AAjCZ;AAqCI;EACI,YAAA;AAnCR;AAqCI;EACI,gFAAA;AAnCR;AAqCI;EACI,uBAAA;AAnCR;AAqCI;EACI,mBAAA;EACA,qCAAA;EACA,iCAAA;EACA,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA,EAAA,WAAA;EACA,2BAAA;EACA,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,uBAAA;EACA,SAAA;EACA,iCAAA;EAEH,kBAAA;AApCL;AAwCI;EACE,aAAA;EACA,wBAAA;EACA,mBAAA;EACA,8BAAA;EAEA,mBAAA;EACA,yBAAA;EACA,mBAAA;EACA,cAAA;EACA,YAAA;EAEA,kCAAA;EACA,kBAAA;EACA,iBAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA,EAAA,WAAA;AAxCN;AA2CA;EACI,eAAA;EACF,aAAA;EACF,0BAAA;EACA,mBAAA;EACA,QAAA;EACA,mBAAA;EACA,kDAAA;EACA,mCAAA;EACA,cAAA;EAEA,kCAAA;EACA,kBAAA;EACA,iBAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA,EAAA,WAAA;AA1CA;AA6CA;EACI,eAAA;EACA,aAAA;EACF,0BAAA;EACA,mBAAA;EACA,QAAA;EACA,mBAAA;EACA,yCAAA;EACA,mCAAA;EACA,cAAA;EAEA,kCAAA;EACA,kBAAA;EACA,iBAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA,EAAA,WAAA;AA5CF;AA+CA;EACI,2BAAA;AA7CJ;AA+CA;EACA,WAAA;EACA,kBAAA;EACA,WAAA;EACA,SAAA;EACA,mBAAA;EACA,UAAA;EACA,kBAAA;EACA,sCAAA;AA7CA;AAiDA;EAEI,kBAAA;EACA,WAAA;EACA,SAAA;EACA,mBAAA;EACA,UAAA;EACA,kBAAA;EACA,qCAAA;AAhDJ;AAoDI;EACI,kEAAA;EACJ,kBAAA;EACA,oBAAA;EACA,iCAAA;EACA,kBAAA;EACA,iBAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA,EAAA,WAAA;AAlDJ;AAuDM;EAAa,aAAA;EACX,wBAAA;AApDR;AAqDQ;EACI,gEAAA;EACA,oCAAA;EACA,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA,EAAA,WAAA;EACJ,iBAAA;AAnDR;AAqDU;EAAuB,uCAAA;EAAyC,UAAA;AAjD1E;AAkDU;EAGE,iCAAA;EACA,kBAAA;EACA,iBAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA,EAAA,WAAA;AAlDZ;AAoDU;EACC,mBAAA;EACC,mBAAA;EACA,sFAAA;EACA,iBAAA;EACA,6BAAA;EACA,yBAAA;AAlDZ;AAqDU;EACE,+CAAA;AAnDZ;AAsDU;EACE,+CAAA;EAGR,iCAAA;EACA,kBAAA;EACA,iBAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA,EAAA,WAAA;AAtDJ;AAwDU;EAGE,gBAAA;EACA,gBAAA;AAxDZ;AA2DQ;EACA;IACA,gBAAA;IACA,gBAAA;EAzDN;EA2DM;IACI,gBAAA;IACA,YAAA;EAzDV;AACF;AA4DU;EACE,0BAAA;EACA,qBAAA;AA1DZ;AA4DU;EACE,uDAAA;AA1DZ;AA4DU;EACE,2BAAA;AA1DZ;AA6DI;EAEI,iBAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,6BAAA;EACA,cAAA;EACA,yBAAA;EACA,gBAAA;EACA,uBAAA;AA5DR;AA+DI;EACI,eAAA;EACJ,mBAAA;EACA,gBAAA;EACA,uBAAA;AA7DJ;AA+DI;EACI,+CAAA;EAEJ,iBAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA,EAAA,WAAA;AA9DJ;AAgEI;EACI,eAAA;EACF,aAAA;EACF,mBAAA;EACA,QAAA;EAEA,mBAAA;EACA,0CAAA;EACA,oCAAA;EACA,0BAAA;EACA,kCAAA;EACA,mDAAA;EACA,kBAAA;EACA,iBAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA,EAAA,WAAA;AA9DJ;AAgEI;EACE,aAAA;EACF,0BAAA;EACA,mBAAA;EACA,QAAA;EACA,mBAAA;EACA,mDAAA;EACA,0CAAA;EACA,oCAAA;EAEA,kCAAA;EACA,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA,EAAA,WAAA;AA/DJ;AAiEI;EACI,eAAA;EACA,aAAA;EACF,mBAAA;EACA,QAAA;EACA,mBAAA;EACA,sCAAA;EACA,mBAAA;EACA,cAAA;EACA,0BAAA;EACA,kCAAA;EACA,kBAAA;EACA,iBAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA,EAAA,WAAA;AA/DN;AAiEI;EACI,eAAA;EACF,aAAA;EACF,0BAAA;EACA,mBAAA;EACA,QAAA;EACA,mBAAA;EACA,0CAAA;EACA,oCAAA;EAEA,iDAAA;EACA,kCAAA;EACA,kBAAA;EACA,iBAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA,EAAA,WAAA;AAhEJ;AAkEI;EAEA,kBAAA,EAIA,WAAA;EACA,qDAAA;EAEA,iCAAA;EACA,kBAAA;EACA,iBAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA,EAAA,WAAA;AAlEJ;AAoEI;EACE,yCAAA;EACA,YAAA;EAEF,iCAAA;EACA,kBAAA;EACA,iBAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA,EAAA,WAAA;AAnEJ;AAqEI;EACE,uDAAA;EACF,kBAAA;EAEA,iBAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA,EAAA,WAAA;AApEJ;AAsEI;EACE,qDAAA;EAEF,iCAAA;EACA,kBAAA;EACA,cAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA,EAAA,WAAA;AArEJ;AAuEI;EACE,qDAAA;EACF,kBAAA;EACA,YAAA;EACA,iBAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA,EAAA,WAAA;AArEJ;AAuEI;EAEA,4BAAA;EACA,0BAAA;AAtEJ;AAwEI;EACE,0BAAA;AAtEN;AAwEI;EACI,2FAAA;EAEF,8BAAA;AAvEN;AA0EI;EACI,cAAA;EACA,2BAAA;EAEA,mBAAA;EACF,eAAA;EACA,MAAA;EACA,SAAA;EACA,UAAA;AAzEN;AA4EI;EACI,WAAA;EACA,2BAAA;EACA,mBAAA;EACF,eAAA;EACA,MAAA;EACA,SAAA;EACA,mBAAA;AA1EN;AA6EI;EACI,oBAAA;EACA,aAAA;EACJ,2BAAA;AA3EJ;AA6EI;EACI,WAAA;EACJ,iBAAA;EACA,2BAAA;AA3EJ;AA6EI;EACI,iBAAA;EACA,WAAA;EACA,2BAAA;AA3ER;AA8EI;EACI,sFAAA,EAAA,yDAAA;EACA,kBAAA;AA5ER;AAgFI;EACI,sBAAA,EAAA,oEAAA;EACA,mBAAA,EAAA,mCAAA;AA9ER;AAkFI;EACI,sBAAA,EAAA,oDAAA;AAhFR;AAmFI;EACI,gBAAA;EACA,YAAA;EAEA,WAAA;EACA,2BAAA;EACA,iBAAA;AAlFR;AA0FI;EACI,yBAAA;EACJ,sFAAA;EACA,oCAAA;EACA,mBAAA;AAxFJ;AA0FI;EACI,uBAAA;EAEJ,iCAAA;EAEA,iBAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA,EAAA,WAAA;EACA,uBAAA;EACA,mBAAA;EACA,gBAAA;AA1FJ;AA6FK;EACG,6EAAA;AA3FR;AA6FK;EACG,+CAAA;AA3FR;AA6FI;EACI,wBAAA;EACA,aAAA;EACJ,gCAAA;EACA,mBAAA;EACA,mBAAA;EACA,WAAA;EACA,gBAAA;EAEA,8BAAA;EACI,8BAAA;EACA,gBAAA;EACA,mBAAA;EACA,2FAAA;AA5FR;AA+FI;EACI,YAAA;EACA,kBAAA;EACA,gBAAA;EAEA,WAAA;EACA,2BAAA;EACA,iBAAA;EACA,gBAAA;EACA,2BAAA;AA9FR;AAgGQ;EACI,kPACI;EAEJ,mBAAA;EACA,gCAAA;AAhGZ;AAmGQ;EAA2B,2BAAA;AAhGnC;AAiGQ;EAA4B,mBAAA;EAAqB,kBAAA;EAAoB,sBAAA;AA5F7E;AA8FI;EACG,8BAAA;EACC,2FAAA;EACR,6EAAA;AA5FA;AA6FQ;EACI,gCAAA;EAAkC,+BAAA;AA1F9C;AA2FY;EAAW,gCAAA;EAAkC,+BAAA;AAvFzD;AA0FI;EAEI,+CAAA;AAzFR;AA2FI;EACI,0DAAA;AAzFR;AA4FI;EACI,cAAA;AA1FR;AA6FI;EACI,gBAAA;EACA,YAAA;EACA,0BAAA;EACA,iBAAA;EACA,kBAAA;EACA,iBAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;AA3FR;AA8FI;EAEI,gBAAA;EACJ,YAAA;EACA,0BAAA;EACA,iBAAA;EACA,kBAAA;EACA,iBAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;AA7FJ;AAmGI;EACI,YAAA;EACJ,iBAAA;EACA,kBAAA;EACA,iBAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;AAjGJ;AAoGI;EACI,YAAA;AAlGR;AAqGI;EACI,gBAAA;EAEA,0BAAA;EACA,iBAAA;EACA,kBAAA;EACA,iBAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;AApGR;AAuGI;EAEI,gBAAA;EACJ,YAAA;EACA,0BAAA;EACA,iBAAA;EACA,kBAAA;EACA,iBAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;AAtGJ;AA0GI;EACI,iBAAA;EACA;cAAA;EAEA,gBAAA;EACA,eAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,cAAA;EACA,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,mBAAA;EACA,+BAAA;EACA,gCAAA;EACA,qCAAA;EACA,2CAAA;EACA,wDAAA;AAxGR;AA0GI;EACI,oBAAA;EACA,aAAA;AAxGR;AA2GI;EACI,mBAAA;EACJ,0BAAA;EACA,YAAA;EACA,2CAAA;EACA,iBAAA;EACA,+pCAAA;EACA,4BAAA;EACA,yBAAA;AAzGJ;AA2GI;EACI,gBAAA;EACA,YAAA;EACA,0BAAA;EACA,iBAAA;EACA,kBAAA;EACA,iBAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;AAzGR;AA2GI;EACI,6BAAA;EACA,kBAAA;EACA,cAAA;EACA;eAAA;EAEA,OAAA;EACA,QAAA;EACA,YAAA;EACD,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,mBAAA;EACC,mBAAA;EACA,YAAA;EACJ,gEAAA;EACA,qFAAA;EAEA,YAAA;EACA,qDAAA;AA1GJ;AA2GQ;EAAK,WAAA;AAxGb;AA2GI;EACI,iBAAA;EACA,YAAA;AAzGR;AA2GI;EACI,gBAAA;EACJ,cAAA;EACA,6BAAA;EACA,gCAAA;EACA,qBAAA;AAzGJ;AA4GI;EACI,SAAA;EACA,aAAA;EACA,sBAAA;EACA,yBAAA;EACA,mBAAA;EACA,qFAAA;EACA,YAAA;EACA,mBAAA;AA1GR;AA4GI;EACI,WAAA;EACA,yBAAA;EACA,YAAA;AA1GR;AA4GI;EACI,gBAAA;EACJ,WAAA;EACA,uBAAA;EACA,kBAAA;EACA,iBAAA;EACA,kBAAA;EACA,gBAAA;EACA,uBAAA;AA1GJ;AA4GI;EACI,mBAAA;EACA,0BAAA;EACA,uBAAA;AA1GR;AA6GI;EACI,eAAA;AA3GR;AA4GQ;EACI,eAAA;EACA,mCAAA;EACA,cAAA;AA1GZ;AA2GY;EAAG,cAAA;AAxGf;AA2GI;EACI,eAAA;AAzGR;AA2GI;EACI,kBAAA;AAzGR;AA4GI;EACI,aAAA;EACA,kBAAA;EACA,mBAAA;EACA,yCAAA;EACA,QAAA;EACA,kBAAA;EACA,iBAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,YAAA;EACA,kBAAA;EACA,kBAAA;EACA,SAAA;EACA,UAAA;EACA,kCAAA;EACA,mBAAA;EACA,2BAAA;AA1GR;AA2GQ;EACI,SAAA;EAAW,2BAAA;EAA6B,UAAA;EAAY,gDAAA;EAAkD,gBAAA;AArGlH;AAsGY;EAAQ,WAAA;EAAa,QAAA;EAAU,SAAA;EAAW,kCAAA;EAAoC,mCAAA;EAAqC,6BAAA;EAA+B,YAAA;EAAc,cAAA;EAAgB,kBAAA;EAAoB,YAAA;EAAc,qBAAA;AAzF9N;AA2FQ;EAAU,aAAA;AAxFlB;AA8FI;EACI,mBAAA;EACR,0CAAA;EACA,oCAAA;EACA,+CAAA;EACA,mBAAA;EACA,aAAA;EACA,uBAAA;EACA,QAAA;EAEA,kCAAA;EACA,kBAAA;EACA,iBAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA,EAAA,WAAA;EACA,0BAAA;AA7FA;AA+FA;EACI,mBAAA;EACJ,0CAAA;EACA,oCAAA;EACA,mBAAA;EACA,aAAA;EACA,uBAAA;EACA,QAAA;EACA,mDAAA;EAEA,kCAAA;EACA,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA,EAAA,WAAA;EACA,0BAAA;AA9FA;AAgGA;EACI,mBAAA;EACA,0CAAA;EACA,oCAAA;EACJ,mBAAA;EACA,aAAA;EACA,uBAAA;EAEA,0BAAA;EACA,QAAA;EAEA,iDAAA;EAEA,kCAAA;EACA,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA,EAAA,WAAA;AAjGA;AAoGA;EACI,0BAAA;EACA,mBAAA;EACA,sFAAA;EACA,gFAAA;EACJ,mBAAA;EACA,aAAA;EACA,uBAAA;EACA,0EAAA;EACA,QAAA;EAEA,kCAAA;EACA,kBAAA;EACA,iBAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA,EAAA,WAAA;AAnGA;AAqGA;EACI,aAAA;EACJ,YAAA;EACA,yBAAA;EACA,mBAAA;EACA,QAAA;EACA,+CAAA;EACA,mBAAA;EACA,wDAAA;EACA,+BAAA;EACA,kBAAA;EACA,iBAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA,EAAA,WAAA;AAnGA;AAqGA;EACI,mBAAA;EACA,kDAAA;EACJ,aAAA;EACA,YAAA;EACA,yBAAA;EACA,mBAAA;EACA,QAAA;EACA,+CAAA;EAEA,+BAAA;EACA,kBAAA;EACA,iBAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA,EAAA,WAAA;AApGA;AAsGA;EACI,yCAAA;EAEJ,kCAAA;EACA,kBAAA;EACA,iBAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA,EAAA,WAAA;AArGA;AAwGA;EACI,cAAA;EACD,yBAAA;EACA,mBAAA;AAtGH;AAwGA;EACI,+CAAA;AAtGJ;AAwGA;EACI,+CAAA;EACJ,8BAAA;EACA,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA,EAAA,WAAA;AAtGA;AAwGA;EACI,iBAAA;AAtGJ;AAyGA;EACI,SAAA;EACA,aAAA;EACA,sBAAA;EACA,yBAAA;EACA,mBAAA;AAvGJ;AA0GA;EACI,yBAAA;EACA,YAAA;AAxGJ;AA6GA;EACI,yCAAA;EAEJ,kCAAA;EACA,iBAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,gBAAA;EACA,gCAAA;AA5GA;AA8GA;EACI,kBAAA;EACA,eAAA;EACA,SAAA;EACA,YAAA;EACA,QAAA;EACA,aAAA;EACA,YAAA;EACA,mBAAA;EACA,gEAAA;EACA,gBAAA;EACA,wDAAA;AA5GJ;AAiHA;EACI,gBAAA;EACA,gBAAA;AA/GJ;AAkHA;EACI,yBAAA;EACA,YAAA;EACA,YAAA;EACA,YAAA;EACA,mBAAA;EACA,YAAA;AAhHJ;AAmHA;EACI,eAAA;EACA,gBAAA;AAjHJ;AAoHA;EACI,YAAA;EACA,eAAA;AAlHJ;AAqHA;EACI,YAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;AAnHJ;AAsHA;EACI,kBAAA;AApHJ;AAuHA;EACI,WAAA;EACA,yBAAA;EACA,YAAA;EACA,mBAAA;EACA,YAAA;AArHJ;AAwHA;EACI,WAAA;EACA,yBAAA;EACA,YAAA;EACA,mBAAA;EACA,YAAA;AAtHJ;AAyHA;EACI,YAAA;EACA,eAAA;EACA,iBAAA;EACA,eAAA;AAvHJ;AA0HA;EACI,YAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;AAxHJ;AA2HA;EACI,kBAAA;EAGA,aAAA;EACA,YAAA;EACA,mBAAA;EACA,gEAAA;EACA,gBAAA;AA3HJ;AAgIA;EACI,yDAAA;EACA,4BAAA;EACA,8BAAA;EACA,gBAAA;EACA,SAAA;EACA,YAAA;EACA,sBAAA;EACA,sBAAA;EACA,mBAAA;EACA,kBAAA;EACA,kBAAA;AA9HJ;AAiIA;EACI,eAAA;EACA,gBAAA;EACA,WAAA;EACA,iBAAA;AA/HJ;AAkIA;EACI,kBAAA;EACA,yBAAA;EACA,YAAA;EACA,gCAAA;EACA,eAAA;EACA,kBAAA;EACA,YAAA;EACA,gBAAA;EACA,8BAAA;AAhIJ;AAmIC;EACG,gBAAA;EACA,eAAA;EACA,WAAA;AAjIJ;AAoIC;EACG,eAAA;EACA,gBAAA;AAlIJ;AAoIC;EACG,yBAAA;EACA,gCAAA;AAlIJ;AAoIC;EACG,YAAA;AAlIJ;AAoIC;EACG,YAAA;AAlIJ;AAqIC;EACG,mBAAA;EACA,qDAAA;EACA,YAAA;EAEA,eAAA;EACA,YAAA;EACA,UAAA;EACA,yBAAA;EACA,YAAA;EACA,gBAAA;EACA,mBAAA;EACA,gEAAA;AApIJ;AAuIE;EACE,YAAA;EACJ,gBAAA;EACA,eAAA;EACA,kBAAA;EACA,YAAA;EACA,kBAAA;AArIA;AAwIE;EAEE,kBAAA;AAvIJ;AA2IE;EACE,aAAA;EAEA,+BAAA;EACA,4BAAA;EACA,WAAA;EACA,mBAAA;EAEA,uBAAA;AA3IJ;AA8IE;EACE,wBAAA;EACA,UAAA;AA5IJ;AAoJI;EACI,+BAAA;AAlJR;AAoJI;EACI,gBAAA;EACJ,yCAAA;EACA,uBAAA;EAEA,8BAAA;EACA,kBAAA;EACA,iBAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA,EAAA,SAAA;AAnJJ;AAwJA;EACI,eAAA;EACA,MAAA;EACA,iCAAA;EACA,SAAA;EACA,OAAA;EACA,QAAA;EACA,kFAAA;EACJ,YAAA;EACA,mBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AAtJA;AAwJA;EAGI,gFAAA;EAEA,eAAA;EACA,qDAAA;EACJ,gBAAA;EACA,eAAA;AAzJA;AA0JQ;EACI,uBAAA;EACA,gBAAA;AAxJZ;AA0JA;EACI,gBAAA;EACA,gBAAA;EACA,uBAAA;AAxJJ;AA0JA;EACA,gBAAA;EACA,YAAA;EACA,uBAAA;EAEA,QAAA;EAcA,8BAAA;EACA,kBAAA;EACA,iBAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA,EAAA,SAAA;AAtKA;AAqJA;EACI,mBAAA;EACA,gFAAA;EAEA,eAAA;EACA,qDAAA;EACA,gBAAA;EACA,eAAA;EACA,uBAAA;EACA,kBAAA;AApJJ;AA8JA;EACI,YAAA;AA5JJ;AA+JA;EACI,+BAAA;AA7JJ;AA+JA;EACI,2EAAA;AA7JJ;AA+JA;EACI,mBAAA;EACJ,2EAAA;EACA,mDAAA;AA7JA;AA+JA;EACI,YAAA;EAEJ,+BAAA;EACA,kBAAA;EACA,iBAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA,EAAA,WAAA;AA9JA;AAgKA;EAEI,mBAAA;EACA,sFAAA;EACA,gFAAA;EACA,kBAAA;EAMA,SAAA;EACA,sDAAA;AApKJ;AA8JI;EACI,kBAAA;EAAoB,UAAA;EAAW,QAAA;EAAU,gEAAA;EAAiE,+DAAA;EAAiE,kBAAA;EAAoB,WAAA;EAAa,YAAA;EAAc,iBAAA;AApJlO;AAqJQ;EAAO,gBAAA;EAAkB,iBAAA;AAjJjC;AAsJA;EACA,YAAA;EAEA,oCAAA;EACA,kBAAA;EACA,iBAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA,EAAA,WAAA;AArJA;AAuJA;EACI,kEAAA;AArJJ;AAuJA;EACI,mBAAA;EACJ,sFAAA;EACA,YAAA;EACA,yBAAA;AArJA;AAuJA;EACI,UAAA;EACA,cAAA;EACA,qBAAA;AArJJ;AAuJA;EACI,YAAA;EACA,oCAAA;AArJJ;AAwJA;EACI,YAAA;EACA,oCAAA;AAtJJ;AAyJA;EACA,YAAA;EAEA,wCAAA;EACA,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA,EAAA,SAAA;AAxJA;AA0JA;EACA,oDAAA;AAxJA;AA0JA;EACA,kBAAA;EACA,kDAAA;EACA,WAAA;EACA,kBAAA;EACA,kBAAA;EACA,cAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;AAxJA;AA0JA;EACA,kBAAA;EACA,kDAAA;EACA,WAAA;EACA,kBAAA;EACA,kBAAA;EACA,cAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;AAxJA;AA0JA;EACA,kBAAA;EACA,8DAAA;EACA,WAAA;EACA,kBAAA;EACA,kBAAA;EACA,cAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;AAxJA;AA0JA;EACA,kBAAA;EACA,kDAAA;EACA,WAAA;EACA,kBAAA;EACA,kBAAA;EACA,cAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;AAxJA;AA6JA;EACI,YAAA;EACA,qBAAA;EACA,YAAA;AA3JJ;AA6JA;EACI,kBAAA;EACA,gFAAA;EAEA,yBAAA;EACC,qDAAA;EACL,SAAA;EACA,sDAAA;AA5JA;AA6JA;EACI,mBAAA;EACA,gEAAA;AA3JJ;AA6JA;EACI,mBAAA;EACA,gEAAA;AA3JJ;AA+JA;EAGI,gCAAA;EACA,qEAAA;EACA,qDAAA;EACA,YAAA;EACA,gBAAA;AA/JJ;AAkKA;EACI,gCAAA;EACA,sCAAA;AAhKJ;AAkKA;EACI,2EAAA;AAhKJ;AAkKM;EACE,qCAAA;AAhKR;AAmKM;EACE,mBAAA;EACR,gFAAA;AAjKA;AAqKM;EACE,eAAA;EACA,YAAA;EACA,kBAAA;EACA,iBAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;AAnKR;AAqKM;EACE,mBAAA;EACR,qCAAA;EACA,2BAAA;EAEA,iCAAA;EACA,kBAAA;EAEA,kBAAA;EACA,gBAAA;EACA,iBAAA,EAAA,WAAA;AArKA;AAuKM;EACE,mBAAA;EACR,sFAAA;AArKA;AAuKM;EACE,mBAAA;EACA,0DAAA;AArKR;AAuKM;EACE,mBAAA;EACR,sFAAA;EACA,uBAAA;EACA,+CAAA;EAEA,oCAAA;EACA,kBAAA;AAtKA;AAyKM;EACE,eAAA;EACA,kEAAA;AAvKR;AA0KC;EAEG,mBAAA;EACA,0CAAA;EACA,oCAAA;EACA,iDAAA;EAEJ,kCAAA;EACA,kBAAA;EACA,iBAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA,EAAA,WAAA;AA1KA;AA4KC;EACG,mBAAA;EACA,wCAAA;EACA,oCAAA;EACA,6CAAA;EAEA,kCAAA;EACA,kBAAA;EACA,iBAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA,EAAA,WAAA;AA3KJ;AA6KC;EACG,yBAAA;AA3KJ;AA6KC;EACG,YAAA;EACJ,iCAAA;EACA,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA,EAAA,WAAA;AA3KA;AA6KC;EACG,8BAAA;EACA,8BAAA;EACA,2BAAA;EACA,2FAAA;EACA,qFAAA;AA3KJ;AA8KC;EACG,8BAAA;EACA,2BAAA;EACA,2FAAA;EACA,0EAAA;AA5KJ;AA8KC;EACG,qFAAA;EAGJ,YAAA;EACA,qDAAA;EACA,0BAAA;EACA,cAAA;AA9KA;AAgLC;EACG,yBAAA;AA9KJ;AAgLC;EAEG,kBAAA;EACA,mCAAA;EAEA,kBAAA;EACJ,gFAAA;EACA,0EAAA;EAEA,yBAAA;EACA,qDAAA;AAjLA;AAmLA;EACI,mBAAA;EACA,gFAAA;AAjLJ;AAmLA;EACI,2FAAA;EACA,sBAAA;AAjLJ;AAoLI;EACI,2FAAA;EACA,uBAAA;AAlLR;AAqLI;EACI,mCAAA;AAnLR;AAqLI;EACI,mCAAA;AAnLR;AAsLI;EACI,qFAAA;EACA,uBAAA;AApLR;AAsLI;EACI,cAAA;EAEJ,iCAAA;EACA,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA,EAAA,WAAA;AArLJ;AAuLI;EACJ,+DAAA;EAEA,cAAA;EACA,mBAAA;AAtLA;AAwLI;EACI,mBAAA;EACA,oEAAA;EACA,gEAAA;EAER,iCAAA;EACA,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA,EAAA,WAAA;AAvLA;AAyLQ;EACI,YAAA;EAEZ,iCAAA;EACA,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA,EAAA,WAAA;AAxLA;AA0LQ;EACJ,qFAAA;AAxLJ;AA2LQ;EACI,0DAAA;AAzLZ;AA2LQ;EACI,qFAAA;EACA,qDAAA;EACA,mBAAA;AAzLZ;AA2LQ;EACJ,4CAAA;EACA,sDAAA;AAzLJ;AAiMG;EACC,kBAAA;EACA,YAAA;AA/LJ;AAkME;EACE,kBAAA;EACA,MAAA;EACA,OAAA;EACA,wBAAA;EACA,YAAA;EACA,sBAAA;EACA,aAAA;EACA,eAAA;EACA,mBAAA;AAhMJ;AAmME;EACE,yBAAA;EACA,iBAAA;EACA,WAAA;EACA,mBAAA;AAjMJ;AAoMA;EACI,yBAAA;EACA,YAAA;EACA,WAAA;EACA,mCAAA;EACA,sBAAA;EACA,2BAAA;AAlMJ;AAsMA;EACI,gCAAA;EACA,YAAA;EACA,WAAA;EACA,sBAAA;AApMJ;AAwMA;EACI,0BAAA;AAtMJ;AAyMA;EACI,yBAAA;EACA,YAAA;EACA,WAAA;EACA,mCAAA;EACA,sBAAA;AAvMJ;AA0MA;EACI,YAAA;EACA,YAAA;EACA,sBAAA;EACA,oCAAA;EACA,8BAAA;EACA,gBAAA;AAxMJ;AA2MA;EACI,YAAA;AAzMJ;AA4MA;EACI,eAAA;EACE,qBAAA;EACA,qBAAA;AA1MN;AA6MA;EACI,YAAA;EACA,yBAAA;EACA,2DAAA;EACA,mBAAA;EACA,iBAAA;EACA,gBAAA;AA3MJ;AA8MA;EACI,mBAAA;AA5MJ;AAgNA;EACI,aAAA;AA9MJ;AAgNC;EACG,yBAAA;EACA,qBAAA;EACA,iBAAA;EACA,eAAA;EACA,mBAAA;EACA,gBAAA;AA9MJ;AAgNC;EACG,kBAAA;AA9MJ;AAiNC;EAA0B,iBAAA;AA9M3B;AAgNC;EACG,kBAAA;AA9MJ;AAmNC;EACG,sBAAA;EACA,uBAAA;EACA,kBAAA;EACA,eAAA;EACA,mBAAA;EACA,gBAAA;EACA,gBAAA;EACA,gBAAA;EACA,kBAAA;EACA,kBAAA;EACA,0DAAA;EACA,uBAAA;AAjNJ;AAoNE;EACE,uBAAA;EACA,aAAA;EACA,YAAA;EACA,gBAAA;EACA,eAAA;EACA,YAAA;EACA,0BAAA;EACA,sCAAA;EACA,kBAAA;AAlNJ;AAqNA;EACI,qFAAA;EACA,wBAAA;EAAA,mBAAA;EACA,YAAA;AAnNJ;AAsNA;EACI,YAAA;AApNJ;AAuNA;EACI,kBAAA;EACA,qBAAA;EACA,YAAA;EACA,YAAA;EACA,YAAA;AArNJ;AAwNA;EACI,kBAAA;EACA,WAAA;EACA,YAAA;EACA,WAAA;EACA,WAAA;EACA,QAAA;EACA,yBAAA;EACA,gBAAA;AAtNJ;AA4NC;EACG,mBAAA;EACA,wBAAA;EAAA,mBAAA;EACA,aAAA;AA1NJ;AA6NA;EACI,UAAA;AA3NJ;AA8NA;EACI,2BAAA;EAEA,iBAAA;AA7NJ;AAgOA;EACI,cAAA;AA9NJ;AAiOA;EACI,eAAA;EACA,YAAA;AA/NJ;AAkOA;EACI,gBAAA;EACA,SAAA;EACA,aAAA;EACA,sBAAA;EACA,sBAAA;EACA,kBAAA;AAhOJ;AAmOA;EACI,iBAAA;AAjOJ;AAoOA;EACI,yBAAA;EACA,YAAA;EACA,YAAA;EACA,mBAAA;AAlOJ;AAqOA;EACI,YAAA;EACA,YAAA;AAnOJ;AAsOA;EACI,gBAAA;EACA,eAAA;AApOJ;AAuOA;EACI,eAAA;AArOJ;AAwOA;EACI,YAAA;EACA,aAAA;EACA,YAAA;AAtOJ;AA0OA;EACI,2BAAA;AAxOJ;AA2OA;EACI,aAAA;AAzOJ;AA4OA;EAAiB,gCAAA;AAzOjB;AA0OA;EAAe,sFAAA;EAAwF,kEAAA;AAtOvG;AAwOA;EACI,yDAAA;EACA,4BAAA;EACA,6BAAA;EACA,gBAAA;EACA,SAAA;EACA,aAAA;EACA,sBAAA;EACA,sBAAA;EACA,mBAAA;EACA,kBAAA;EACA,kBAAA;AAtOJ;AAyOA;EACI,mCAAA;EACA,eAAA;AAvOJ;AA0OE;EACE,kBAAA;EACA,qBAAA;EACA,WAAA;EACA,YAAA;AAxOJ;AA2OE;EACE,UAAA;EACA,QAAA;EACA,SAAA;AAzOJ;AA4OE;EACE,kBAAA;EACA,eAAA;EACA,MAAA;EACA,OAAA;EACA,QAAA;EACA,SAAA;EACA,yBAAA;EAEA,gBAAA;AA1OJ;AA6OE;EACE,kBAAA;EACA,WAAA;EACA,YAAA;EACA,WAAA;EACA,SAAA;EACA,SAAA;EACA,yBAAA;EACA,gBAAA;AA3OJ;AA8OE;EACE,yBAAA;AA5OJ;AA+OE;EACE,wCAAA;AA7OJ;AAgPE;EAGE,2BAAA;EACA,sCAAA;AA9OJ;AAmPA;EACI,YAAA;AAjPJ;AAuPE;EACE,gBAAA;EACA,YAAA;AArPJ;AAwPA;EACI,cAAA;EACA,iBAAA;EACA,kBAAA;EACA,gBAAA;EACA,gBAAA;AAtPJ;AAyPA;EACI,kBAAA;EACA,mBAAA;EACA,8BAAA;AAvPJ;AA0PA;EACI,YAAA;AAxPJ;AA2PA;EACI,cAAA;AAzPJ;AA4PA;EACI,kBAAA;EACA,qBAAA;EACA,WAAA;EACA,YAAA;AA1PJ;AA6PE;EACE,UAAA;EACA,QAAA;EACA,SAAA;AA3PJ;AA8PE;EACE,kBAAA;EACA,eAAA;EACA,MAAA;EACA,OAAA;EACA,QAAA;EACA,SAAA;EACA,yBAAA;EAEA,gBAAA;AA5PJ;AA+PE;EACE,kBAAA;EACA,WAAA;EACA,YAAA;EACA,WAAA;EACA,SAAA;EACA,QAAA;EACA,yBAAA;EACA,gBAAA;AA7PJ;AAgQE;EACE,kBAAA;EACA,QAAA;EACA,iBAAA;EACA,gBAAA;AA9PJ;AAiQE;EACE,kBAAA;EACA,QAAA;EACA,kBAAA;EACA,gBAAA;AA/PJ;AAkQE;EACE,yBAAA;AAhQJ;AAmQE;EACE,wCAAA;AAjQJ;AAoQE;EAGE,2BAAA;EACA,yBAAA;AApQJ;AAwQE;EACE,mBAAA;AAtQJ;AAyQE;EACE,mBAAA;AAvQJ;AA0QE;EACE,aAAA;EACA,6BAAA;AAxQJ;AA2QE;EACE,kBAAA;EACA,aAAA;AAzQJ;AA4QE;EACE,kBAAA;EACA,aAAA;AA1QJ;AA8QA;EACI,UAAA;AA5QJ;AAgRE;EACE,mBAAA;AA9QJ;AAkRE;EACE,mBAAA;EACA,mBAAA;AAhRJ;AAoRE;EACE,mBAAA;AAlRJ;AAsRE;EAAgD,mBAAA;EAAqB,gCAAA;EAAkC,kBAAA;EAAoB,cAAA;EAAgB,qBAAA;EAAuB,eAAA;EAAiB,WAAA;EAAa,YAAA;EAAc,iBAAA;EAAmB,kBAAA;EAAoB,kBAAA;EAAoB,6BAAA;EAA+B,UAAA;EAAY,sBAAA;AAtQtT;AAwQE;EAAY,cAAA;AArQd;AAuQE;EAA0B,yBAAA;AApQ5B;AAuQC;EACG,yBAAA;EACA,qBAAA;EACA,iBAAA;EACA,eAAA;EACA,mBAAA;EACA,gBAAA;EACA,YAAA;EACA,eAAA;AArQJ;AAwQC;EACG,kBAAA;EACA,0CAAA;EACA,mBAAA;EACA,yCAAA;EACA,kBAAA;EACA,kBAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;AAtQJ;AAyQC;EACG,mBAAA;EACA,yBAAA;AAvQJ;AA4QC;EAAa,WAAA;EAAa,YAAA;EAAc,kBAAA;EAAoB,iBAAA;EAAmB,mBAAA;AArQhF;AAsQA;EAAoC,YAAA;AAnQpC;AAoQC;EAAkC,0BAAA;AAjQnC;AAkQC;EAAuB,kBAAA;EAAoB,0BAAA;AA9P5C;AA+PA;EAAyC,WAAA;EAAa,YAAA;EAAc,kBAAA;EAAoB,iBAAA;EAAmB,mBAAA;AAxP3G;AAyPA;EAAkE,yBAAA;AAtPlE;AAuPA;EAAqC,kBAAA;EAAoB,QAAA;EAAU,SAAA;EAAW,yBAAA;EAA2B,yBAAA;EAA2B,UAAA;EAAY,kBAAA;EAAoB,kBAAA;EAAoB,mBAAA;EAAqB,iDAAA;AA3O7M;AA4OA;EAA6D,YAAA;EAAc,SAAA;AAxO3E;AAyOA;EAA+C,aAAA;EAAe,mBAAA;AArO9D;AAsOA;EAAuD,cAAA;AAnOvD;AAoOA;EAA+D,mBAAA;AAjO/D;AAkOA;EAAmD,sBAAA;EAAwB,iBAAA;EAAmB,iBAAA;AA7N9F;AA8NA;EACI,sFAAA;EACA,iBAAA;EACA,mBAAA;AA5NJ;AA8NA;EAAkB,yBAAA;AA3NlB;;AA+NA;EAAuC,yBAAA;EAA2B,cAAA;EAAgB,8CAAA;EAAgD,kBAAA;EAAoB,mBAAA;AAvNtJ;;AAwNA;EAA6C,2BAAA;AApN7C;;AAuNA;EAA2B,iFAAA;AAnN3B;;AAoNA;EAA0B,WAAA;EAAa,cAAA;EAAgB,wBAAA;EAA0B,YAAA;EAAc,cAAA;EAAgB,0DAAA;AA3M/G","sourcesContent":[".DarkTheme{\n    text{\n        fill: white !important;\n    }\n    .main-wrapper{\n        transition: all 0.25s ease-in;\n        overflow: hidden;\n        position: relative;\n        margin: 0;\n      padding: 0;\n      background: var(--foundation-neutral-dark-theme-neutral-dark-theme-900, #1F2020);\n     min-height: 100vh; \n     transition:all 0.2s ease-in-out;\n     max-height: 100vh;\n    }\n    \n    .content-body{\n        margin-left: 15rem;\n        margin-bottom: 1rem;\n        margin-right: 1rem;\n        //background: var(--foundation-neutral-dark-theme-neutral-dark-theme-700, #343535);\n        border-radius: 14px;\n        \n    \n    }\n    .content-body-collapse{\n        margin-left: 6rem;\n        background: var(--foundation-neutral-dark-theme-neutral-dark-theme-700, #343535);\n        transition: margin-left 0.4s ease;\n        margin-bottom: 1rem;\n        margin-right: 1rem;\n        margin-right: 1rem;\n        border-radius: 14px;\n        margin-top: 1rem;\n    }\n    .text-custom{\n        color: white;\n    }\n    .table-custom{\n        background: var(--foundation-neutral-dark-theme-neutral-dark-theme-700, #343535);\n        height: 89vh;\n        //overflow-y: auto;\n        border-radius: 12px;\n     }\n\n     .rdt_Table, .rdt_TableHeader, .rdt_ExpanderRow {background: var(--foundation-neutral-dark-theme-neutral-dark-theme-700, #343535); color: var(--text-white-high-emphasis, #FCFCFE);}\n\n     .rdt_Table > div {background: var(--foundation-neutral-dark-theme-neutral-dark-theme-700, #343535); color: var(--text-white-high-emphasis, #FCFCFE);}\n\n     .rdt_TableRow{\n        min-height: 60px !important;\n    }\n    .shift-table .rdt_TableRow{\n        border-bottom: 2px solid var(--neutral-dark-400) !important;\n     }\n\n    .rdt_TableCell{\n        padding-left: 5px !important;\n        padding-right: 5px !important;\n    }\n    \n    .rdt_TableHeadRow{\n        background: #494B4B !important;;\n        border-radius: 12px;\n        min-height: 38px !important;\n        border-radius: 12px;\n    }\n    \n    .rdt_TableBody{\n        overflow: scroll;\n        height: calc(100vh - 277px);\n        padding-bottom: 60px;\n        padding-right: 8px;\n        background: var(--foundation-neutral-dark-theme-neutral-dark-theme-700, #343535);\n    }\n\n\n     .rdt_TableHead{\n        background: var(--foundation-neutral-dark-theme-neutral-dark-theme-700, #343535) !important; color: var(--text-white-high-emphasis, #FCFCFE);\n    }\n    .rdt_TableBody{\n        background: var(--foundation-neutral-dark-theme-neutral-dark-theme-700, #343535); color: var(--text-white-high-emphasis, #FCFCFE);\n    }\n    .rdt_TableRow{\n        background: var(--foundation-neutral-dark-theme-neutral-dark-theme-700, #343535); color: var(--text-white-high-emphasis, #FCFCFE);\n        border-bottom: none !important;\n        button[aria-label=\"Expand Row\"], button[aria-label=\"Collapse Row\"]{color: var(--text-white-high-emphasis, #FCFCFE);}\n    }\n    \n     .bMuwEY{\n        border-radius: 0 !important;\n     }\n     .iGDrkx{\n        background: var(--foundation-neutral-dark-theme-neutral-dark-theme-700, #343535) !important;\n     }\n    .button-toggle{\n       margin-right: -1.8rem;\n      color: black;\n    }\n\n    .nav-options-nested-option{\n        color: var(--text-white-high-emphasis, #FCFCFE);\n        border-radius: 14px;\n        font-family: Inter;\n        font-size: 0.7rem;\n        font-style: normal;\n        font-weight: 600;\n        line-height: 120%;\n        margin-top: -45px;\n        margin-bottom: 15px;\n        margin-left: 39px;\n    }\n\n    .nav-options{\n        color: var(--text-white-high-emphasis, #FCFCFE);\n        border-radius: 14px;\n        font-family: Inter;\n        font-size: 0.8rem;\n        font-style: normal;\n        font-weight: 600;\n        line-height: 120%;\n        //width: 11.9rem \n    }\n\n    .nav-options-hovered{\n        color:black;\n        background: var(--primary);\n        border-radius: 14px; \n    /* Typography/Body/Default/Bold */\n    font-family: Inter;\n    font-size: 0.8rem;\n    font-style: normal;\n    font-weight: 600;\n    line-height: 120%; /* 16.8px */\n    width: 11.9rem \n    }\n    .nav-options:hover{\n        background: var(--primary);\n        color: black;\n        font-weight: 600;\n    }\n    .toggleSwitch{\n        background: var(--foundation-neutral-neutral-500, #DCE4F1);\n    \n    }\n\n     //neted nav options\n\n     .nav-options-nested{\n        color: var(--text-white-high-emphasis, #FCFCFE);\n     \n        border-radius: 14px; \n    /* Typography/Body/Default/Bold */\n    font-family: Inter;\n    font-size: 0.6rem;\n    font-style: normal;\n    font-weight: 600;\n    line-height: 120%; /* 16.8px */\n    }\n    .nav-options-nested:hover{\n        background: var(--primary);\n        color: black;\n        font-weight: 600;\n    }\n   \n\n    // css for banner\n    .banner{\n        margin:1rem;\n       \n        margin-left: 15rem;\n         background: linear-gradient(269deg, var(--primary) 14.5%, var(--secondary-700) 87.34%, var(--secondary-700) 87.34%);\n        \n     }\n     .banner-collapse{\n        \n         margin:1rem;\n         margin-left: 6rem;\n         background: linear-gradient(269deg, var(--primary) 14.5%, var(--secondary-700) 87.34%, var(--secondary-700) 87.34%);\n     }\n     .txt-title{\n         color: var(--text-white-high-emphasis, #FCFCFE);\n     \n         /* Typography/Heading 5/Bold */\n         \n         font-size: 1rem;\n         font-style: normal;\n         font-weight: 600;\n         line-height: 120%; /* 28.8px */  \n     }\n     .btn-banner{\n        \n     border: 2px solid rgba(255, 255, 255, 0.80);\n     background: var(--foundation-secondary-secondary-400, var(--primary));\n     box-shadow: 0px 10px 31px 0px var(--primary-opactiy-40);\n     color: #323146;\n     \n     /* Typography/Body/Default/Bold */\n     font-family: Inter;\n     font-size: 0.7rem;\n     font-style: normal;\n     font-weight: 600;\n     line-height: 120%; /* 16.8px */\n     }\n     //css for header top\n     .headerTop{\n        margin-left:12rem;\n        display:flex;\n        align-items: center;\n        justify-content: flex-end;\n        border-bottom: 1px solid  #494B4B; \n        }\n        .headerTop-collapse{\n            margin-left:4rem;\n        border-bottom: 1px solid #494B4B; \n          \n            display:flex;\n        align-items: center;\n        justify-content: flex-end;\n        }\n       .fa-chevron-down{\n        color: var(--text-white-medium-emphasis, rgba(252, 252, 254, 0.60));\n       }\n        .fa-circle{\n            font-size: 8px;\n        }\n        .fa-circle-question{\n            color:var(--text-white-high-emphasis, #FCFCFE); ;\n\n        }\n        .headerSecond{\n            margin-left: 14rem ;\n            display:flex;\n            align-items: center;\n            justify-content:space-between;\n        }\n        .headerSecond-collapse{\n            margin-left:5rem;\n            display:flex;\n            align-items: center;\n            justify-content:space-between;\n        }\n        .image-logo{\n        border: 2px solid var(--foundation-neutral-neutral-400, #494B4B); \n        }\n        .fa-lock{\n           color:  var(--text-white-medium-emphasis, rgba(252, 252, 254, 0.60));\n            font-size: 10px;\n        }\n       \n        .image-logo-second{\n            color: var(--text-white-high-emphasis, #FCFCFE);\n        \n        /* Typography/Heading 5/Bold */\n        \n        font-size: 1rem;\n        font-style: normal;\n        font-weight: 600;\n        line-height: 120%; /* 28.8px */\n        }\n        .groupid{\n            color: var(--text-white-medium-emphasis, rgba(252, 252, 254, 0.60)); \n        \n        /* Typography/Body/Default/Regular */\n        font-family: Inter;\n        font-size: 0.6rem;\n        font-style: normal;\n        font-weight: 400;\n        line-height: 130%; /* 18.2px */\n        }\n        .bell{\n            border: 2px solid var(--foundation-neutral-dark-theme-neutral-dark-theme-500, #494B4B); \n        }\n        .fa-bell{\n            color:var(--text-white-high-emphasis, #FCFCFE); ;\n        }\n        .sub-grp{\n            border-radius: 14px;\n            border: 2px solid var(--primary);\n            background: var(--foundation-secondary-secondary-400, var(--primary));\n            color: var(--text-high-emphasis, #090826);\n            font-family: Inter;\n            font-size: 0.8rem;\n            font-style: normal;\n            font-weight: 600;\n            line-height: 120%;\n        }\n\n        .delete-obj{\n            background: var(--Error-error-button-enabled, #FF6969);\n            box-shadow: 0px 10px 31px 0px #FF696966;\n            font-weight: 600;\n        }\n        .sub-grp:hover{\n            background: var(--secondary-300);\n            //border: 2px solid var(--secondary-300);\n        }\n        .notificationcard{\n            position: absolute;\n            /* bottom:0; */\n            top:18px;\n           right:0;\n            z-index: 1000;\n            width:300px;\n           \n            border-radius: 14px;\n        border: 1px solid var(--foundation-neutral-neutral-400, #E3E9F4);\n        background: #FFF;\n        \n        /* popover */\n        box-shadow: 10px 14px 74px 0px rgba(92, 96, 101, 0.20);\n        }\n        \n        .bgOne{\n            background: var(--foundation-neutral-neutral-500, #DCE4F1);\n        }\n        .notification{\n            color: var(--text-high-emphasis, #090826);\n        \n        /* Typography/Body/Large/Regular */\n        font-size: 0.7rem;\n        font-style: normal;\n        font-weight: 400;\n        line-height: 120%;\n        text-align: left;\n        z-index: 100000000;\n        }\n        .notification-card{\n            border-top: 1px solid #E3E9F4;\n           \n        }\n        .notification-card:hover{\n            border-radius: 14px;\n            background: var(--foundation-neutral-neutral-400, #E3E9F4);\n        }\n        .notification-img{\n            border: 2px solid var(--foundation-neutral-neutral-400, #E3E9F4); \n            height: 40px; \n        min-width: 40px;\n        }\n        .notification-heading{\n            // color: var(--text-high-emphasis, #090826);\n            color:white;\n        /* Typography/Heading 6/Bold */\n        font-family: Inter;\n        text-align: left;\n        font-size: 0.8rem;\n        font-style: normal;\n        font-weight: 600;\n        line-height: 120%; /* 24px */ \n        }\n        .notification-description{\n            color: var(--text-medium-emphasis, rgba(9, 8, 38, 0.60));\n        text-align: left;\n        /* Typography/Body/Default/Regular */\n        font-family: Inter;\n        font-size: 0.8rem;\n        font-style: normal;\n        font-weight: 400;\n        line-height: 130%; /* 18.2px */\n        }\n        .profile{\n            z-index: 1000;\n        }\n        .profile-name{\n            // color: var(--text-high-emphasis, #090826);\n        \n        /* Typography/Body/Default/Bold */\n        font-family: Inter;\n        font-size: 0.8rem;\n        font-style: normal;\n        font-weight: 600;\n        line-height: 120%; /* 16.8px */\n        }\n        .isactive{\n            // color: var(--text-high-emphasis, #090826);\n        \n        /* Typography/Body/Default/Regular */\n        font-family: Inter;\n        font-size: 0.7rem;\n        font-style: normal;\n        font-weight: 400;\n        line-height: 130%; /* 18.2px */\n        }\n        .profileCards{\n            border-top: 1px solid #E3E9F4;\n          \n            // color: var(--text-high-emphasis, #090826);\n        \n            /* Typography/Body/Default/Regular */\n            font-family: Inter;\n            font-size: 0.8rem;\n            font-style: normal;\n            font-weight: 400;\n            line-height: 130%; /* 18.2px */\n        }\n        .profilehover:hover{\n            border-radius: 14px;\n            background: var(--foundation-neutral-neutral-400, #777777);\n        }\n        .profileCards{\n            display: flex;\n            flex-direction: column;\n        }\n    //  css for main subgroup table \n\n    .theader{\n        color:white\n    }\n    .rdt_TableHeader {\n        background: var(--foundation-neutral-dark-theme-neutral-dark-theme-700, #343535);\n    }\n    .lffUrX:not(:last-of-type){\n        border:none  !important;\n    }\n    .tab{\n        border-radius: 14px;\n        background: var(--primary-opactiy-20);\n        /* Typography/Body/Default/Bold */\n        font-family: Inter;\n        font-size: 14px;\n        font-style: normal;\n        font-weight: 600;\n        line-height: 120%; /* 16.8px */\n        color: var(--secondary-200); \n        display: flex;\n        flex-direction: column;\n        justify-content: center;\n        align-items: flex-start;\n        gap: 12px;\n        /* Typography/Body/Default/Bold */\n      \n     position: relative;\n     \n    }\n\n    .type-roles{\n      display: flex;\n      padding: 4px 6px 4px 7px;\n      align-items: center;\n      justify-content: space-between;\n    //   gap: 8px;\n      border-radius: 54px;\n      border: 2px solid #C8CFDB;\n      background:#E3E9F4;\n      color: #090826;\n      width: 129px;\n      \n      /* Typography/Body/Small/Regular */\n      font-family: Inter;\n      font-size: 0.8rem;\n      font-style: normal;\n      font-weight: 400;\n      line-height: 120%; /* 14.4px */\n}\n\n.type-pending-provision{\n    cursor: pointer;\n  display: flex;\npadding: 4px 16px 4px 12px;\nalign-items: center;\ngap: 8px;\nborder-radius: 54px;\nborder: 2px solid #F6B63780;\nbackground: #F6B63733;\ncolor:#87641E;\n\n/* Typography/Body/Small/Regular */\nfont-family: Inter;\nfont-size: 0.8rem;\nfont-style: normal;\nfont-weight: 400;\nline-height: 120%; /* 14.4px */\n}\n\n.type-requested{\n    cursor: pointer;\n    display: flex;\n  padding: 4px 16px 4px 12px;\n  align-items: center;\n  gap: 8px;\n  border-radius: 54px;\n  border: 2px solid var(--secondary-300)80;\n  background: #F6B63733;\n  color:#87641E;\n  \n  /* Typography/Body/Small/Regular */\n  font-family: Inter;\n  font-size: 0.8rem;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 120%; /* 14.4px */\n}\n\n.tab.form{\n    color: var(--secondary-500);\n}\n.tab::before{\ncontent:'';\nposition:absolute;\nheight: 4px;\nbottom: 0;\nborder-radius: 20px;\nwidth:70%;\nalign-self: center;\nbackground-color: var(--secondary-500);\n}\n\n\n.tab.form::before {\n\n    position:absolute;\n    height: 4px;\n    bottom: 0;\n    border-radius: 20px;\n    width:70%;\n    align-self: center;\n    background-color: var(--secondary-50);\n\n}\n   \n    .tab-unactive{\n        color: var(--text-white-medium-emphasis, rgba(252, 252, 254, 0.60)); \n    align-self: center;\n    justify-self: center;\n    /* Typography/Body/Default/Bold */\n    font-family: Inter;\n    font-size: 0.8rem;\n    font-style: normal;\n    font-weight: 600;\n    line-height: 130%; /* 18.2px */\n    }\n    \n    \n      \n      input:focus {padding: none;\n        outline: none !important}\n        .search-input::placeholder {\n            color: var(--text-white-low-emphasis, rgba(252, 252, 254, 0.32));\n            /* Typography/Body/Default/Regular */\n            font-family: Inter;\n            font-size: 14px;\n            font-style: normal;\n            font-weight: 400;\n            line-height: 130%; /* 18.2px */ \n        text-align: right;\n          }\n          .custom-input:disabled{background-color: rgba(67, 67, 67, 0.7); opacity: 1;}\n          .custom-input::placeholder{\n            \n            //color: var(--text-low-emphasis, rgba(9, 8, 38, 0.32));\n            /* Typography/Body/Default/Bold */\n            font-family: Inter;\n            font-size: 0.8rem;\n            font-style: normal;\n            font-weight: 400;\n            line-height: 120%; /* 16.8px */\n          }\n          .search-input,.custom-input{\n           padding-right:20px ;\n            border-radius: 14px;\n            border: 2px solid var(--foundation-neutral-dark-theme-neutral-dark-theme-500, #494B4B);\n            font-size: 0.8rem;\n            background-color: transparent;\n            color: rgb(255, 255, 255);\n          }\n         \n          .fa-search,.fa-arrow-down-short-wide,.dark-optimise{\n            color: var(--text-white-high-emphasis, #FCFCFE); \n          }\n         \n          .text-style{\n            color: var(--text-white-high-emphasis, #FCFCFE);\n\n    \n    /* Typography/Body/Default/Bold */\n    font-family: Inter;\n    font-size: 0.8rem;\n    font-style: normal;\n    font-weight: 400;\n    line-height: 120%; /* 16.8px */\n          }\n          .celVQH{\n            //     overflow-y: auto;\n            //    max-height: 67vh;\n            overflow-y: auto;\n            max-height: 28vh;\n        }\n    \n        @media (min-width: 1600px) {\n        .celVQH{\n        overflow-y: auto;\n        max-height: 45vh;\n        }\n        .permission-page{\n            overflow: scroll;\n            height: 55vh;\n        }\n    }\n \n          .iGDrkx{\n            min-height: 0px !important;\n            padding: 0 !important;\n          }\n          .fa-chevron-right{\n            color: var(--text-medium-emphasis, rgba(9, 8, 38, 0.60)); \n          }\n          .lffUrX{\n            min-height: 60px !important;\n          }\n    \n    .text-heading{\n        //color: var(--text-high-emphasis, #090826);\n        font-size: 0.8rem;\n        font-style: normal;\n        font-weight: 600;\n        line-height: 120%;\n        word-break: normal !important;\n        max-width: 6vw;\n        /* white-space: nowrap; */\n        overflow: hidden;\n        text-overflow: ellipsis;\n    }\n\n    .desc-box{\n        max-width: 14vw;\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    }\n    .text-detail{\n        color: var(--text-white-high-emphasis, #FCFCFE); \n    \n    font-size: 0.7rem;\n    font-style: normal;\n    font-weight: 400;\n    line-height: 120%; /* 14.4px */\n    }\n    .type-department{\n        cursor: pointer;\n      display: flex;\n    align-items: center;\n    gap: 8px;\n    border-radius: 54px;\n    border-radius: 54px;\n    border: 2px solid rgba(255, 205, 175, 0.50);\n    background: rgba(255, 205, 175, 0.20);\n    padding: 4px 16px 4px 12px;\n    /* Typography/Body/Small/Regular */\n    color: var(--foundation-orange-orange-200, #FFCDAF); \n    font-family: Inter;\n    font-size: 0.8rem;\n    font-style: normal;\n    font-weight: 400;\n    line-height: 120%; /* 14.4px */\n    }\n    .type-project{\n      display: flex;\n    padding: 4px 16px 4px 12px;\n    align-items: center;\n    gap: 8px;\n    border-radius: 54px;\n    color: var(--foundation-purple-purple-200, #D2BCFC); \n    border: 2px solid rgba(210, 188, 252, 0.50);\n    background: rgba(210, 188, 252, 0.20);\n    \n    /* Typography/Body/Small/Regular */\n    font-family: Inter;\n    font-size: 12px;\n    font-style: normal;\n    font-weight: 400;\n    line-height: 120%; /* 14.4px */\n    }\n    .type-initiated{\n        cursor: pointer;\n        display: flex;\n      align-items: center;\n      gap: 8px;\n      border-radius: 54px;\n      border: 2px solid var(--secondary-300);\n      background: #d4ebf2;\n      color:  #3590ae;\n      padding: 4px 16px 4px 12px;\n      /* Typography/Body/Small/Regular */\n      font-family: Inter;\n      font-size: 0.8rem;\n      font-style: normal;\n      font-weight: 400;\n      line-height: 120%; /* 14.4px */\n      }\n    .type-Client{\n        cursor: pointer;\n      display: flex;\n    padding: 4px 16px 4px 12px;\n    align-items: center;\n    gap: 8px;\n    border-radius: 54px;\n    border: 2px solid rgba(186, 238, 138, 0.50);\n    background: rgba(186, 238, 138, 0.20);\n\n    color: var(--foundation-green-green-200, #BAEE8A); \n    /* Typography/Body/Small/Regular */\n    font-family: Inter;\n    font-size: 0.8rem;\n    font-style: normal;\n    font-weight: 400;\n    line-height: 120%; /* 14.4px */\n    }\n    .folder{\n      color: var(--text-low-emphasis, rgba(9, 8, 38, 0.32));\n    text-align: center;\n    \n    font-style: normal;\n    font-weight: 400;\n    line-height: 120%; /* 19.2px */\n    color: var(--text-low-emphasis, rgba(9, 8, 38, 0.32));\n    \n    /* Typography/Body/Default/Bold */\n    font-family: Inter;\n    font-size:  0.8rem;\n    font-style: normal;\n    font-weight: 600;\n    line-height: 120%; /* 16.8px */\n    }\n    .setting{\n      color: var(--text-high-emphasis, #090826);\n      width: 120px;\n      \n    /* Typography/Body/Default/Bold */\n    font-family: Inter;\n    font-size: 0.8rem;\n    font-style: normal;\n    font-weight: 500;\n    line-height: 120%; /* 16.8px */\n    }\n    .member{\n      color: var(--text-medium-emphasis, rgba(9, 8, 38, 0.60));\n    text-align: center;\n    \n    font-size: 0.8rem;\n    font-style: normal;\n    font-weight: 400;\n    line-height: 120%; /* 19.2px */\n    }\n    .folder-0{\n      color: var(--text-low-emphasis, rgba(9, 8, 38, 0.32));\n    \n    /* Typography/Body/Default/Bold */\n    font-family: Inter;\n    font-size: 0.8;\n    font-style: normal;\n    font-weight: 500;\n    line-height: 120%; /* 16.8px */\n    }\n    .setting-0{\n      color: var(--text-low-emphasis, rgba(9, 8, 38, 0.32));\n    text-align: center;\n    width: 120px;\n    font-size: 0.8rem;\n    font-style: normal;\n    font-weight: 400;\n    line-height: 120%; /* 19.2px */\n    }\n    .cQAWmj{\n     \n    /* height: 20px!important; */\n    min-height: 0px !important;\n    }\n    .lhMoHC{\n      min-width: 50px !important;\n    }\n    .lffUrX:hover {\n        background: var(--foundation-neutral-dark-theme-neutral-dark-theme-600, #424444) !important; \n    \n      border-radius: 14px !important;\n    }\n    // sidebar css  \n    .Navheader{\n        width: 13.7rem;\n        transition: width 0.4s ease;\n        // background: var(--foundation-neutral-dark-theme-neutral-dark-theme-500, #494B4B);\n        background: #002d72;\n      position: fixed; \n      top:0;\n      bottom:0;\n      z-index: 9;\n    \n    }\n    .Navheader-collapse{\n        width: 5rem;\n        transition: width 0.4s ease;\n        background: #002d72;      \n      position: fixed; \n      top:0;\n      bottom:0;\n      z-index: 1000000000;\n    \n    }\n    .dbtez{\n        /* width: 11.5rem; */\n        width: 8.5rem;\n    transition: width 0.4s ease;\n    }\n    .icon{\n        width: 40px;\n    font-size: 1.3rem;\n    transition: width 0.4s ease;\n    }\n    .icon-collapse{\n        font-size: 1.1rem;\n        width:auto;\n        transition: width 0.4s ease;\n    }\n\n    .navoptionsall::-webkit-scrollbar-track {\n        background-color: var(--foundation-neutral-dark-theme-neutral-dark-theme-500, #494B4B); /* Change this to match your sidebar's background color */\n        padding-left: 10px;\n    }\n    \n    /* Style the scrollbar thumb */\n    .navoptionsall::-webkit-scrollbar-thumb {\n        background-color: #666; /* Change this to match the color you want for the scrollbar thumb */\n        border-radius: 10px; /* Adjust border radius as needed */\n    }\n    \n    /* Style the scrollbar on hover */\n    .navoptionsall::-webkit-scrollbar-thumb:hover {\n        background-color: #999; /* Change this to a lighter shade for hover effect */\n    }\n    \n    .navoptionsall{\n        margin-top: 33px;\n        height: 80vh;\n        //border-top: 2px solid rgba(109, 111, 111, 0.6352941176);\n        width: auto;\n        transition: width 0.4s ease;\n        margin-right: 5px;\n    }\n\n    // @media (min-height: 774px) {}\n    //     .navoptionsall {\n    //         overflow-y: hidden;\n    //     }\n\n    .dbtez{\n        /* border-radius: 14px; */\n    border: 2px solid var(--foundation-neutral-dark-theme-neutral-dark-theme-300, #858686);\n    background: rgba(255, 255, 255, 0.20);\n    align-items: center;\n    }\n    .row-label{\n        color: white !important; \n    \n    /* Typography/Body/Default/Bold */\n    \n    font-size: 0.7rem;\n    font-style: normal;\n    font-weight: 600;\n    line-height: 120%; /* 16.8px */\n    text-overflow: ellipsis;\n    white-space: nowrap;\n    overflow: hidden;\n    }\n  \n     .setting-0{\n        color: var(--text-white-medium-emphasis, rgba(252, 252, 254, 0.60))!important;\n     }\n     .not-0,.setting{\n        color: var(--text-white-high-emphasis, #FCFCFE); \n     }\n    .fEnJOm{\n        min-height: 0 !important;\n        display: flex;\n    /* padding: 8px 16px 8px 64px; */\n    align-items: center;\n    align-self: stretch;\n    margin: 4px;\n    margin-top: 12px;\n    \n    border-bottom:none !important;\n        border-radius: 14px !important;\n        padding-top: 2px;\n        padding-bottom: 2px;\n        background: var(--foundation-neutral-dark-theme-neutral-dark-theme-600, #424444) !important;\n\n    }\n    .navoptionsallcollapse{\n        height: 80vh;\n        overflow-y: scroll;\n        margin-top: 33px;\n        //border-top: 2px solid rgba(109, 111, 111, 0.6352941176);\n        width: auto;\n        transition: width 0.4s ease;\n        margin-right: 5px;\n        border-top: none;\n        z-index: 2000000 !important;\n\n        .optionsDropdownCard{\n            background:\n                linear-gradient(var(--primary-opactiy-20), var(--primary-opactiy-20)),\n                linear-gradient(var(--foundation-neutral-dark-theme-neutral-dark-theme-500, #494B4B), var(--foundation-neutral-dark-theme-neutral-dark-theme-500, #494B4B)) top;\n            border-radius: 14px;\n            transform: translate(60px, -50%);\n        }\n\n        .nav-options.activeOption {z-index: 9999999 !important;}\n        &:has(.optionsDropdownCard){overflow-y: visible; position: relative; z-index: -1 !important;}\n    }\n    .rdt_Pagination{\n       border-radius: 14px !important;\n        background: var(--foundation-neutral-dark-theme-neutral-dark-theme-600, #424444) !important;\ncolor: var(--text-white-medium-emphasis, rgba(252, 252, 254, 0.60)) !important;\n        button {\n            color: rgba(252, 252, 254, 0.54); fill: rgba(252, 252, 254, 0.54);\n            &:disabled{color: rgba(252, 252, 254, 0.18); fill: rgba(252, 252, 254, 0.18);}\n        }\n    }\n    .kZkdeH:disabled{\n\n        color: var(--text-white-high-emphasis, #FCFCFE); \n    }\n    .kZkdeH{\n        color: var(--text-white-high-emphasis, #FCFCFE) !important; \n    }\n\n    .options-dropdown {\n        width: 10.5rem;\n    }\n\n    .options-heading {\n        overflow: hidden;\n        color: white;\n        /* text-overflow: unset; */\n        margin-left: 23px;\n        font-family: Inter;\n        font-size: 0.8rem;\n        font-style: normal;\n        font-weight: 600;\n        line-height: 120%;\n    }\n\n    .nav-options-heading {\n\n        overflow: hidden;\n    color: white;\n    /* text-overflow: unset; */\n    margin-left: 23px;\n    font-family: Inter;\n    font-size: 0.8rem;\n    font-style: normal;\n    font-weight: 600;\n    line-height: 120%;\n\n    }\n\n\n\n    .roles-heading{\n        color: white;\n    margin-left: 23px;\n    font-family: Inter;\n    font-size: 0.8rem;\n    font-style: normal;\n    font-weight: 600;\n    line-height: 120%;\n    }\n\n    .textBlack{\n        color: black\n    }\n    \n    .options-heading-submenu{\n        overflow: hidden;\n        // color: white;\n        /* text-overflow: unset; */\n        margin-left: 23px;\n        font-family: Inter;\n        font-size: 0.8rem;\n        font-style: normal;\n        font-weight: 600;\n        line-height: 120%;\n    }\n\n    .options-heading-active {\n\n        overflow: hidden;\n    color: black;\n    /* text-overflow: unset; */\n    margin-left: 23px;\n    font-family: Inter;\n    font-size: 0.8rem;\n    font-style: normal;\n    font-weight: 600;\n    line-height: 120%;\n\n    }\n\n    .optionsDropdownCard{\n        margin-top: -20px;\n        /* position: relative;\n        bottom: 0; */\n        /* top: 255px; */\n        font-size: 18px;\n        /* left: 9px; */\n        z-index: 9999999;\n        /* color: white; */\n        width: 11.8rem;\n        display: flex;\n        flex-direction: column;\n        justify-content: center;\n        align-items: center;\n        border-bottom-left-radius: 14px;\n        border-bottom-right-radius: 14px;\n        background: var(--primary-opactiy-20);\n        border: 1px solid var(--primary-opactiy-20);\n        box-shadow: 10px 14px 74px 0px var(--primary-opactiy-10);\n    }\n    .options-dropdown {\n        /* width: 11.5rem; */\n        width: 8.5rem;\n    }\n\n    .activeOption{\n        border-radius: 14px;\n    background: var(--primary);\n    color: black;\n    /* background: var(--primary-opactiy-20); */\n    /* color: #333; */\n    /* background-image: url(data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjAiIGhlaWdodD0iMjAiIHZpZXdCb3g9IjAgMCAyMCAyMCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPG1hc2sgaWQ9Im1hc2swXzI1NzlfNzc2MjAiIHN0eWxlPSJtYXNrLXR5cGU6YWxwaGEiIG1hc2tVbml0cz0idXNlclNwYWNlT25Vc2UiIHg9IjAiIHk9IjAiIHdpZHRoPSIyMCIgaGVpZ2h0PSIyMCI+CjxyZWN0IHdpZHRoPSIyMCIgaGVpZ2h0PSIyMCIgZmlsbD0iI0Q5RDlEOSIvPgo8L21hc2s+CjxnIG1hc2s9InVybCgjbWFzazBfMjU3OV83NzYyMCkiPgo8cGF0aCBkPSJNOC4yMjkxNyAxMS45Mzc1TDEzLjcyOTIgNi40NTgzNEMxMy44ODE5IDYuMzA1NTYgMTQuMDU1NiA2LjIzMjY0IDE0LjI1IDYuMjM5NTlDMTQuNDQ0NCA2LjI0NjUzIDE0LjYxODEgNi4zMjYzOSAxNC43NzA4IDYuNDc5MTdDMTQuOTIzNiA2LjYzMTk1IDE1IDYuODA1NTYgMTUgNy4wMDAwMUMxNSA3LjE5NDQ1IDE0LjkyMzYgNy4zNjgwNiAxNC43NzA4IDcuNTIwODRMOC43NzA4MyAxMy41MjA4QzguNjE4MDYgMTMuNjczNiA4LjQ0MDk3IDEzLjc1IDguMjM5NTggMTMuNzVDOC4wMzgxOSAxMy43NSA3Ljg2MTExIDEzLjY3MzYgNy43MDgzMyAxMy41MjA4TDUuMjI5MTcgMTEuMDQxN0M1LjA3NjM5IDEwLjg4ODkgNSAxMC43MTUzIDUgMTAuNTIwOEM1IDEwLjMyNjQgNS4wNzYzOSAxMC4xNTI4IDUuMjI5MTcgMTBDNS4zODE5NCA5Ljg0NzIzIDUuNTU1NTYgOS43NzA4NCA1Ljc1IDkuNzcwODRDNS45NDQ0NCA5Ljc3MDg0IDYuMTE4MDYgOS44NDcyMyA2LjI3MDgzIDEwTDguMjI5MTcgMTEuOTM3NVoiIGZpbGw9IiMwOTA4MjYiLz4KPC9nPgo8L3N2Zz4K); */\n    background-repeat: no-repeat;\n    background-position: left;\n    }\n    .options-heading {\n        overflow: hidden;\n        color: white;\n        /* text-overflow: unset; */\n        margin-left: 23px;\n        font-family: Inter;\n        font-size: 0.8rem;\n        font-style: normal;\n        font-weight: 600;\n        line-height: 120%;\n    }\n    .organisationDropdownCard{\n        z-index: 200000000 !important;\n        position: absolute;\n        /* bottom:0; */\n        /* top: 40px;\n        left: 20px; */\n        left: 0;\n        top: 92%;\n        width:11rem;\n       display: flex;\n       flex-direction: column;\n       justify-content: center;\n       align-items: center;\n        border-radius: 14px;\n        color: white;\n    border: 2px solid var(--foundation-neutral-neutral-400, #494B4B);\n    background: var(--main-neutral-dark-theme-neutral-dark-theme-700, #343535) !important;\n    \n    /* popover */\n    box-shadow: 10px 14px 74px 0px rgba(92, 96, 101, 0.20);\n        >div{width: 100%;}\n    }\n\n    .plus-icon{\n        margin-left: 16px;\n        color:white;\n      }\n    .organisations{\n        max-height: 40vh;\n    overflow: auto;\n    border-top: 2px solid  #494B4B;\n    border-bottom: 2px solid  #494B4B;\n    border-color: #494B4B;\n    \n    }\n    .select-custom-input {\n        flex: 1 1;\n        padding: 10px;\n        box-sizing: border-box;\n        border: 2px solid #494B4B;       \n        border-radius: 12px;\n        background: var(--main-neutral-dark-theme-neutral-dark-theme-700, #343535) !important;\n        width: 425px;\n        margin-bottom: 15px;\n    }\n    .organisation-img{\n        width: 23px;\n        border:1px solid #E3E9F4;\n        padding: 2px;\n    }\n    .organisation-heading{\n        overflow: hidden;\n    color:#fff;\n    text-overflow: ellipsis;\n    font-family: Inter;\n    font-size: 0.8rem;\n    font-style: normal;\n    font-weight: 600;\n    /* line-height: 120%; */\n    }\n    .oragnisationHover:hover{\n        border-radius: 14px;\n        background: var(--primary);\n        color: black !important;\n    \n    }\n    .oragnisationHover{\n        cursor: pointer;\n        button {\n            font-size: 10px;\n            color: #09082652;\n            display: block;\n            i {display: block;}\n        }\n    }\n    .new:hover{\n        cursor: pointer;\n    }\n    .nav-options{\n        position: relative;\n    \n    }\n    .tooltip {\n        display: flex;\n        position: absolute;\n        background: #000000;\n        color: var(--text-high-emphasis, #090826);\n        gap: 8px;\n        font-family: Inter;\n        font-size: 0.8rem;\n        font-style: normal;\n        font-weight: 400;\n        line-height: 130%;\n        padding: 5px;\n        width: max-content;\n        border-radius: 4px;\n        top: 10px;\n        left: 50px;\n        z-index: 90000000000000 !important;\n        text-align: justify;\n        /* display: inline-block; */\n        &.tooltip-top {\n            left: 50%; transform: translateX(-50%); top: -18px; box-shadow: 3px 4px 16px 0 rgba(0, 11, 65, 0.15); padding: 2px 5px;\n            &:after{content: \"\"; width: 0; height: 0; border-left: 5px solid transparent; border-right: 5px solid transparent; border-top: 5px solid #000000; font-size: 0; line-height: 0; position: absolute; bottom: -5px; left: calc(50% - 5px);}\n        }\n        &.hidden {display: none;}\n      }\n      \n\n\n    //tabletask\n    .status{\n        border-radius: 54px;\nborder: 2px solid rgba(128, 229, 234, 0.50);\nbackground: rgba(128, 229, 234, 0.20);\ncolor: var(--foundation-blue-blue-200, #c5f3f5);\nalign-items: center;\ndisplay: flex;\njustify-content: center;\ngap:8px;\n\n/* Typography/Body/Small/Regular */\nfont-family: Inter;\nfont-size: 0.8rem;\nfont-style: normal;\nfont-weight: 400;\nline-height: 120%; /* 14.4px */\npadding: 4px 16px 4px 12px;\n    }\n.status-inprogress{\n    border-radius: 54px;\nborder: 2px solid rgba(255, 205, 175, 0.50);\nbackground: rgba(255, 205, 175, 0.20);\nalign-items: center;\ndisplay: flex;\njustify-content: center;\ngap:8px;\ncolor: var(--foundation-orange-orange-200, #FFCDAF);\n\n/* Typography/Body/Small/Regular */\nfont-family: Inter;\nfont-size: 12px;\nfont-style: normal;\nfont-weight: 400;\nline-height: 120%; /* 14.4px */\npadding: 4px 16px 4px 12px; \n}\n.status-done{\n    border-radius: 54px;\n    border: 2px solid rgba(186, 238, 138, 0.50);\n    background: rgba(186, 238, 138, 0.20); \nalign-items: center;\ndisplay: flex;\njustify-content: center;\n\npadding: 4px 16px 4px 12px; \ngap:8px;\n\ncolor: var(--foundation-green-green-200, #BAEE8A);\n\n/* Typography/Body/Small/Regular */\nfont-family: Inter;\nfont-size: 12px;\nfont-style: normal;\nfont-weight: 400;\nline-height: 120%; /* 14.4px */\n\n}\n.status-backlog{\n    padding: 4px 16px 4px 12px; \n    border-radius: 54px;\n    border: 2px solid var(--foundation-neutral-dark-theme-neutral-dark-theme-300, #858686);\n    background: var(--foundation-neutral-dark-theme-neutral-dark-theme-500, #494B4B);\nalign-items: center;\ndisplay: flex;\njustify-content: center;\ncolor: var(--foundation-neutral-dark-theme-neutral-dark-theme-50, #EDEDED); \ngap:8px;\n\n/* Typography/Body/Small/Regular */\nfont-family: Inter;\nfont-size: 0.8rem;\nfont-style: normal;\nfont-weight: 400;\nline-height: 120%; /* 14.4px */\n}\n.dueto-today{\n    display: flex;\nheight: 32px;\npadding: 0px 8px 0px 12px;\nalign-items: center;\ngap: 4px;\ncolor: var(--text-white-high-emphasis, #FCFCFE);\nborder-radius: 20px;\nbackground: var(--foundation-orange-orange-500, #FF9251);\n/* Typography/Body/Small/Bold */\nfont-family: Inter;\nfont-size: 0.8rem;\nfont-style: normal;\nfont-weight: 600;\nline-height: 120%; /* 14.4px */\n}\n.dueto-past{\n    border-radius: 20px;\n    background: var(--foundation-red-red-500, #FF6969);\ndisplay: flex;\nheight: 32px;\npadding: 0px 8px 0px 12px;\nalign-items: center;\ngap: 4px;\ncolor: var(--text-white-high-emphasis, #FCFCFE);\n\n/* Typography/Body/Small/Bold */\nfont-family: Inter;\nfont-size: 0.8rem;\nfont-style: normal;\nfont-weight: 600;\nline-height: 120%; /* 14.4px */\n}\n.duto-text{\n    color: var(--text-high-emphasis, #090826);\n\n/* Typography/Body/Small/Regular */\nfont-family: Inter;\nfont-size: 0.8rem;\nfont-style: normal;\nfont-weight: 400;\nline-height: 120%; /* 14.4px */\n}\n// element progress bar\n.progressbar{\n    color:#E3E9F4;\n   background-color: #E3E9F4;\n   border-radius: 14px;\n}\n.table-text-dark{\n    color: var(--text-white-high-emphasis, #FCFCFE);\n}\n.task{\n    color: var(--text-white-high-emphasis, #FCFCFE);\n/* Typography/Heading 5/Bold */\nfont-family: Inter;\nfont-size: 24px;\nfont-style: normal;\nfont-weight: 600;\nline-height: 120%; /* 28.8px */\n}\n.z-index-10000{\n    z-index: 10000000;\n}\n\n.custom-input{\n    flex: 1 1;\n    padding: 10px;\n    box-sizing: border-box;\n    border: 2px solid #494B4B;\n    border-radius: 12px;\n}\n\n.custom-logo-upload:hover{\n    background-color: #ededed;\n    color:black\n  }\n\n//members table css \n\n.members{\n    color: var(--text-high-emphasis, #090826);\n\n/* Typography/Body/Large/Regular */\nfont-size: 0.7rem;\nfont-style: normal;\nfont-weight: 400;\nline-height: 120%;\ntext-align: left;\nborder-bottom: 1px solid #E3E9F4;\n}\n.memberscard {\n    position: absolute;\n    /* bottom: 0; */\n    top: 32px;\n    left: -115px;\n    right: 0;\n    z-index: 1000;\n    width: 300px;\n    border-radius: 14px;\n    border: 1px solid var(--foundation-neutral-neutral-400, #E3E9F4);\n    background: #FFF;\n    box-shadow: 10px 14px 74px 0px var(--primary-opactiy-10);\n}\n\n\n///roleInfo pop up\n.permissions-tab{\n    min-width: 615px;\n    overflow: scroll;\n}\n\n.permission-badge{\n    background-color: #EFF3F9;\n    color: black;\n    padding: 8px;\n    width: 315px;\n    border-radius: 15px;\n    height: 37px;\n}\n\n.permission-text{\n    font-size: 11px;\n    font-weight: 500;\n}\n\n.team-label-img{\n    height: 40px;\n    min-width: 40px;\n}\n\n.team-label-heading{\n    color: white;\n    font-family: Inter;\n    text-align: left;\n    font-size: 0.6rem;\n    font-style: normal;\n    font-weight: 600;\n    line-height: 120%;\n}\n\n.project-info{\n    margin-left: 360px;\n}\n\n.permission-info{\n    width: 80px;\n    background-color: #F0FBE6;\n    padding: 8px;\n    border-radius: 15px;\n    height: 37px;\n}\n\n.permission-rejected{\n    width: 80px;\n    background-color: #FFF0F0;\n    padding: 8px;\n    border-radius: 15px;\n    height: 37px;\n}\n\n.permission-table{\n    height: 15px;\n    min-width: 16px;\n    margin-left: 22px;\n    margin-top: 2px;\n}\n\n.permission-warning{\n    height: 10px;\n    min-width: 12px;\n    margin-top: -3px;\n    margin-left: 15px;\n}\n\n.permission-approval{\n    position: absolute;\n    //top: 245px;\n    //right: 290px;\n    z-index: 1000;\n    width: 275px;\n    border-radius: 14px;\n    border: 1px solid var(--foundation-neutral-neutral-400, #E3E9F4);\n    background: #FFF;\n}\n\n//accordion css\n\n.team-mate-accordion{\n    background-image: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAFLSURBVHgBnZLfTcMwEMbv7Lhx/RQ2sASuEC+UDdoNwgSUDViBDWCCZgPYoGWC8ogEEt6APiGranLYSaiqJqmqfJJj6/78fPlkhD0liU6cEykA6ipSLJ37WsIR4f9BqfOUcj73keSgxhJsps5Z2wZgu+aCv9TEx20e3RCwKUN69iGNJFZCmDF0aShH32FJqfVhLjT6HA2lWbQ2KzVKQ4GUZtZ5wdA8VTXNC1hRQDlansN7F4CI1zkxaQCIcA0ni9sGADEv6Zxj2tXGoJhUJ2dbC0oTY/PT5nQcXzzUHs3beqPw2eZ0GzFcRBxWnJvMh97q/B0CTqop2rV7SFJeaobFKxFc7xcQUMYAkUoYZb/u874xQfl37sP6bSzElV9bHWKDwWa5XtvSZCVHHoYzJQ0cQk6Wh2TBD9XhRy8IQg8FSPAklpsz6Ktgetj/ANwtaoEESpAOAAAAAElFTkSuQmCC);\n    background-repeat: no-repeat;\n    background-position: 12px 14px;\n    min-width: 394px;\n    flex: 1 1;\n    padding: 9px;\n    box-sizing: border-box;\n    border: 1px solid #ccc;\n    border-radius: 10px;\n    margin-right: 12px;\n    padding-left: 36px;\n}\n\n.members-count{\n    font-size: 11px;\n    font-weight: 500;\n    margin: 2px;\n    margin-right: 9px;\n}\n\n.accordion-btn {\n    padding: 14px 20px;\n    background-color: #343535;\n    color: white;\n    border-bottom: 2px solid #E3E9F4;\n    cursor: pointer;\n    margin-right: 10px;\n    width: 599px;\n    text-align: left;\n    justify-content: space-between;\n }\n\n .accordion-label{\n    font-weight: 700;\n    font-size: 13px;\n    margin: 7px;\n }\n\n .accordion-content {\n    font-size: 20px;\n    margin-top: 20px;\n }\n .accordion-btn:hover {\n    background-color: #EFF3F9;\n    border-bottom: 2px solid #E3E9F4;\n }\n .accordion-btn:active {\n    border:none;\n }\n .accordion-btn:focus {\n    border:none;\n }\n\n .notification {\n    z-index:9999999999;\n    box-shadow: 10px 14px 74px 0px #5C606533;\n    width: 400px;\n    //height: 129px;\n    position: fixed;\n    bottom: 20px;\n    left: 20px;\n    background-color: #343535;\n    color: white;\n    padding: 0px 0px;\n    border-radius: 14px;\n    transition: transform 0.3s ease-in-out, opacity 0.3s ease-in-out;\n  }\n\n  .notification-message{\n    color: white;\nfont-weight: 600;\nfont-size: 14px;\nmargin-bottom: 5px;\npadding: 5px;\nborder-radius: 5px;\n  }\n\n  .msg-container {\n    //display: flex;\n    padding: 20px 20px;\n    //justify-content: space-between;\n  }\n\n  .notification-icon {\n    display: flex;\n    //height: 129px;\n    border-bottom-left-radius: 14px;\n    border-top-left-radius: 14px;\n    width: 95px;\n    align-items: center;\n    //background: #E3E9F4;\n    justify-content: center;\n  }\n  \n  .notification.show {\n    transform: translateX(0);\n    opacity: 1;\n  }\n\n\n\n///task popup css\n\n.overlay{\n    .border-right{\n        border-right: 1px solid #E3E9F4;\n    }\n    .title{\n        overflow: hidden;\n    color: var(--text-high-emphasis, #090826);\n    text-overflow: ellipsis;\n\n    /* Typography/Heading 3/Bold */\n    font-family: Inter;\n    font-size:1.8rem;\n    font-style: normal;\n    font-weight: 600;\n    line-height: 120%; /* 42px */\n    }\n}\n///task popup css\n\n.overlay{\n    position: fixed;\n    top:0;\n    z-index: 2000000000000!important;\n    bottom: 0;\n    left: 0;\n    right:0;\n    background: var(--foundation-neutral-neutral-900, #5c6065c1);\nwidth:100vw;\n/* height: 100vh; */\ndisplay: flex;\nalign-items: center;\njustify-content: center;\n\n.taskPopUp, .memberPopup, .modalPopup{\n\n    //border-radius: 24px;\n    background: var(--foundation-neutral-dark-theme-neutral-dark-theme-700, #343535);\n    \n    /* modal page */\n    box-shadow: 10px 14px 114px 0px rgba(31, 32, 32, 0.40);\nmax-height: 95vh;\nmin-width: auto;\n        &.h-auto{\n            height: auto!important;\n            min-height: auto;\n        }\n.scrollable{\n    max-height: 65vh;\n    overflow-y: auto;\n    scroll-behavior: smooth;\n }\n.title{\noverflow: hidden;\ncolor:white;//color for dark mode\ntext-overflow: ellipsis;\n\n/* org */\n\n.orgCreate{\n    border-radius: 24px;\n    background: var(--foundation-neutral-dark-theme-neutral-dark-theme-700, #343535);\n    \n    /* modal page */\n    box-shadow: 10px 14px 114px 0px rgba(31, 32, 32, 0.40);\n    min-height: 80vh;\n    min-width: auto;\n    height: 50vh !important;\n    overflow-x: hidden;\n}\n\n/* Typography/Heading 3/Bold */\nfont-family: Inter;\nfont-size:1.8rem;\nfont-style: normal;\nfont-weight: 600;\nline-height: 120%; /* 42px */\n}\n.title-text-small-color{\n    color:white\n}\n}\n.border-right{\n    border-right: 1px solid #E3E9F4;\n}\n.play-pause{\n    background: var(--foundation-secondary-secondary-800, var(--secondary-500));\n}\n.play-pause-button{\n    border-radius: 50px;\nbackground: var(--foundation-secondary-secondary-500, var(--secondary-700));\nbox-shadow: 0px 4px 8px 0px rgba(92, 96, 101, 0.06);\n}\n.sum-title{\n    color: white;\n\n/* Typography/Body/Large/Bold */\nfont-family: Inter;\nfont-size: 0.9rem;\nfont-style: normal;\nfont-weight: 500;\nline-height: 120%; /* 19.2px */\n}\n.uploadedFile{\n\n    border-radius: 14px;\n    border: 2px solid var(--foundation-neutral-dark-theme-neutral-dark-theme-500, #494B4B);\n    background: var(--foundation-neutral-dark-theme-neutral-dark-theme-500, #494B4B);\n    position: relative;\n    & > button{\n        position: absolute; top:-10px; right: 0; border:2px solid var(--foundation-neutral-neutral-400, #E3E9F4); background-color: var(--foundation-neutral-neutral-50, #FCFCFE); border-radius: 50%; width: 16px; height: 16px; line-height: 12px;\n        & > i {font-size: 0.7em; line-height: 12px;}\n    }\n    \n    /* card */\n    box-shadow: 10px 14px 14px 0px rgba(92, 96, 101, 0.08);\n.filename{\ncolor: white;\n\n/* Typography/Body/Default/Regular */\nfont-family: Inter;\nfont-size: 0.8rem;\nfont-style: normal;\nfont-weight: 400;\nline-height: 130%; /* 18.2px */\n}\n.icon-color{\n    color: var(--text-white-medium-emphasis, rgba(252, 252, 254, 0.60)); \n}\n.input-custom{\n    border-radius: 14px;\nborder: 2px solid var(--foundation-neutral-dark-theme-neutral-dark-theme-400, #6D6F6F);\ncolor: white;\nbackground-color:#6D6F6F ;\n}\ninput::placeholder, textarea::placeholder {\n    opacity: 1;\n    color: #9ca3af;\n    background: aliceblue;\n  }\ntextarea::placeholder{\n    color: white;\n    background-color:#6D6F6F !important; \n}\n\n.input-custom::placeholder{\n    color: white;\n    background-color:#6D6F6F !important; \n}\n\n.fileDetail{\ncolor: white;\n\n/* Typography/Body/Extra Small/Regular */\nfont-family: Inter;\nfont-size: 10px;\nfont-style: normal;\nfont-weight: 400;\nline-height: 120%; /* 12px */\n}\n.document-svg{\nbox-shadow: 2px 4px 10px 0px rgba(92, 96, 101, 0.24);\n}\n.pdf{\nborder-radius: 1px;\nbackground: var(--foundation-red-red-500, #FF6969);\ncolor: #FFF;\ntext-align: center;\nfont-family: Inter;\nfont-size: 8px;\nfont-style: normal;\nfont-weight: 600;\nline-height: normal;\n}\n.default{\nborder-radius: 1px;\nbackground: var(--foundation-red-red-500, #48792f);\ncolor: #FFF;\ntext-align: center;\nfont-family: Inter;\nfont-size: 8px;\nfont-style: normal;\nfont-weight: 600;\nline-height: normal;  \n}\n.png{\nborder-radius: 1px;\nbackground: var(--foundation-dark-blue-dark-blue-500, #6C9BF6);\ncolor: #FFF;\ntext-align: center;\nfont-family: Inter;\nfont-size: 8px;\nfont-style: normal;\nfont-weight: 600;\nline-height: normal;  \n}\n.svg{\nborder-radius: 1px;\nbackground: var(--foundation-red-red-500, #f09409);\ncolor: #FFF;\ntext-align: center;\nfont-family: Inter;\nfont-size: 8px;\nfont-style: normal;\nfont-weight: 600;\nline-height: normal;\n}\n}\n}\n\n.alert {\n    height: auto;\n    align-items: flex-end;\n    left: -175px;\n}\n.popup{\n    border-radius: 8px;\n    background: var(--foundation-neutral-dark-theme-neutral-dark-theme-500, #494B4B);\n    \n    /* popover - dark theme */\n     box-shadow: 10px 14px 114px 0px rgba(31, 32, 32, 0.40);\n/* card */\nbox-shadow: 10px 14px 14px 0px rgba(92, 96, 101, 0.08); \n.description-txt{\n    border-radius: 14px;\n    border: 1px solid var(--foundation-neutral-neutral-400, #E3E9F4);\n}\n.link-txt{\n    border-radius: 14px;\n    border: 1px solid var(--foundation-neutral-neutral-400, #E3E9F4);\n}\n\n}\n.btn-popup{\n   \n  \n    border: 2px solid var(--primary);\n    background: var(--foundation-secondary-secondary-400, var(--primary));\n    box-shadow: 0px 5px 5px 0px var(--primary-opactiy-40);\n    color: black;\n    font-weight: 600;\n\n}\n.btn-popup:hover{\n    background: var(--secondary-300);\n    border: 2px solid var(--secondary-300);\n}\n.bg-btn-teal{\n    background:  var(--foundation-secondary-secondary-500, var(--secondary-700)); \n      }  \n      .border-btn-select{\n        border:2px solid rgba(9, 8, 38, 0.60);\n      }\n      \n      .sidebar-data-todo{\n        border-radius: 14px;\nbackground: var(--foundation-neutral-dark-theme-neutral-dark-theme-500, #494B4B);\n     \n      \n      }\n      .sidebar-txt{\n        margin-top: 5px;\n        color: white;\n        font-family: Inter;\n        font-size: 0.8rem;\n        font-style: normal;\n        font-weight: 400;\n        line-height: 130%;\n      }\n      .task-tab{\n        border-radius: 14px;\nbackground: var(--primary-opactiy-20);\ncolor: var(--secondary-200);\n\n/* Typography/Body/Default/Bold */\nfont-family: Inter;\n\nfont-style: normal;\nfont-weight: 600;\nline-height: 120%; /* 16.8px */\n      }\n      .comment-box{\n        border-radius: 14px;\nborder: 2px solid var(--foundation-neutral-dark-theme-neutral-dark-theme-500, #494B4B);\n      }\n      .todo-hover:hover{\n        border-radius: 14px;\n        background: var(--foundation-neutral-neutral-400, #E3E9F4);\n      }\n      .dropdown-task{\n        border-radius: 14px;\nborder: 2px solid var(--foundation-neutral-dark-theme-neutral-dark-theme-400, #6D6F6F);\nbackground: transparent;\ncolor: var(--text-white-high-emphasis, #FCFCFE);\n\n/* Typography/Body/Default/Regular */\nfont-family: Inter;\n\n      }\n      .progress-estimated{\n        font-size: 10px;\n        color: var(--text-white-medium-emphasis, rgba(252, 252, 254, 0.60)); \n      }\n      //custom member\n .active-status{\n  \n    border-radius: 54px;\n    border: 2px solid rgba(186, 238, 138, 0.50);\n    background: rgba(186, 238, 138, 0.20);\n    color: var(--foundation-green-green-200, #BAEE8A); \n\n/* Typography/Body/Small/Regular */\nfont-family: Inter;\nfont-size: 0.8rem;\nfont-style: normal;\nfont-weight: 400;\nline-height: 120%; /* 14.4px */\n }\n .unactive-status{\n    border-radius: 54px;\n    border: 2px solid rgba(255, 64, 64, 0.5);\n    background: rgba(255, 105, 105, 0.20);\n    color: var(--foundation-red-red-200, #FF9B9B);\n    \n    /* Typography/Body/Small/Regular */\n    font-family: Inter;\n    font-size: 0.8rem;\n    font-style: normal;\n    font-weight: 400;\n    line-height: 120%; /* 14.4px */\n }\n .dropdown-custom{\n    background-color: #6D6F6F;\n }\n .member-section-title{\n    color: white;\n/* Typography/Body/Default/Bold */\nfont-family: Inter;\nfont-size: 14px;\nfont-style: normal;\nfont-weight: 600;\nline-height: 120%; /* 16.8px */\n }\n .dropdown-container{\n    border-radius: 15px !important;\n    border: transparent  !important;\n    box-shadow: none !important;\n    border: 2px solid var(--main-neutral-dark-theme-neutral-dark-theme-400, #6D6F6F)!important;\n    background: var(--main-neutral-dark-theme-neutral-dark-theme-700, #343535)!important;;\n    \n }\n .dropdown-container:focus-within{\n    border: transparent !important;\n    box-shadow: none !important;\n    border: 2px solid var(--main-neutral-dark-theme-neutral-dark-theme-400, #6D6F6F) !important;\n    background: var(--main-neutral-dark-theme-neutral-dark-theme-500, #494B4B);\n }\n .dropdown-custom{\n    background:var(--main-neutral-dark-theme-neutral-dark-theme-500, #494B4B) !important;\n   \n\n/* popover */\nbox-shadow: 10px 14px 74px 0px rgba(92, 96, 101, 0.20);\nz-index: 100000 !important;\ndisplay: block;\n }\n .rmsc .gray{\n    color: #9ca3af!important ;\n }\n .dropdown-menu{\n\n    position: absolute;\n    z-index: 100000000000000 !important;\n\n    border-radius: 8px;\nborder: 2px solid var(--main-neutral-dark-theme-neutral-dark-theme-400, #6D6F6F);\nbackground: var(--main-neutral-dark-theme-neutral-dark-theme-500, #494B4B);\n\n/* popover - dark theme */\nbox-shadow: 10px 14px 114px 0px rgba(31, 32, 32, 0.40);\n}\n.dropdown, .btn-simple{\n    border-radius: 14px;\n    border: 2px solid var(--main-neutral-dark-theme-neutral-dark-theme-400, #6D6F6F);\n}\n.dropdown-options:hover, .dropdown-content{\n    background-color: var(--main-neutral-dark-theme-neutral-dark-theme-700, #343535) !important;\n    color: #fff !important;\n    \n    }\n    .panel-content{\n        background-color: var(--main-neutral-dark-theme-neutral-dark-theme-700, #343535) !important;\n        width: 215px !important;;\n    }\n\n    .rmsc .select-item:hover {\n        background: rgba(89, 221, 211, 0.20);\n    }\n    .rmsc .select-item.selected {\n        background: rgba(89, 221, 211, 0.20);\n    }\n\n    .rmsc .search input{\n        background: var(--main-neutral-dark-theme-neutral-dark-theme-700, #343535) !important;\n        color: white !important;\n    }\n    .invite-link{\n        color: #9ca3af;\n    \n    /* Typography/Body/Default/Bold */\n    font-family: Inter;\n    font-size: 14px;\n    font-style: normal;\n    font-weight: 600;\n    line-height: 120%; /* 16.8px */\n    }\n    .btn-green{\nbackground: var(--main-secondary-secondary-400, var(--primary));\n\ncolor: #090826;\nborder-radius: 14px; \n    }\n    .navtab-active{\n        border-radius: 14px;\n        background: var(--main-secondary-secondary-50, var(--secondary-200));\n        color: var(--main-secondary-secondary-800, var(--secondary-500));\n\n/* Typography/Body/Default/Bold */\nfont-family: Inter;\nfont-size: 14px;\nfont-style: normal;\nfont-weight: 600;\nline-height: 120%; /* 16.8px */\n        }\n        .navtab-unactive{\n            color: white;\n\n/* Typography/Body/Default/Bold */\nfont-family: Inter;\nfont-size: 14px;\nfont-style: normal;\nfont-weight: 600;\nline-height: 120%; /* 16.8px */\n        }\n        .PhoneInputInput{\n    background: var(--main-neutral-dark-theme-neutral-dark-theme-700, #343535)!important;;\n          \n        }\n        .txt-green{\n            color: var(--main-secondary-secondary-400, var(--primary)); \n        }\n        .multi-dropdown{\n            background:var(--main-neutral-dark-theme-neutral-dark-theme-500, #494B4B) !important;\n            box-shadow: 10px 14px 74px 0px rgba(92, 96, 101, 0.20);\n            border-radius: 14px;\n        }\n        .btn-red{\n    background: var(--main-red-red-500, #FF6969);\n    box-shadow: 0px 10px 31px 0px rgba(255, 105, 105, 0.40);\n           }\n     \n \n\n\n   //team pop up css \n\n   .multiselect-wrapper {\n    position: relative;\n    color:black;\n  }\n  \n  .pill-container {\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: calc(100% - 30px);\n    padding: 3px;\n    box-sizing: border-box;\n    display: flex;\n    flex-wrap: wrap;\n    align-items: center;\n  }\n  \n  .pill {\n    background-color: #e0e0e0;\n    padding: 5px 10px;\n    margin: 5px;\n    border-radius: 20px;\n  }\n\n.form-steps-active {\n    background-color: #C8CFDB;\n    height: 40px;\n    width: 40px;\n    box-shadow: 0 0 0 3px #343535 inset;\n    box-sizing: border-box;\n    border: 2.5px solid #C8CFDB;\n    //border-radius: 999999px;\n}\n\n.form-steps-complete {\n    background-color: var(--primary);\n    height: 35px;\n    width: 35px;\n    box-sizing: border-box;\n    //border-radius: 999999px;\n}\n\n.divider{\n    background: var(--primary);\n}\n\n.form-steps{\n    background-color: #C8CFDB;\n    height: 40px;\n    width: 40px;\n    box-shadow: 0 0 0 3px #343535 inset;\n    box-sizing: border-box;\n}\n\n.rmsc .dropdown-container {\n    width: 215px;\n    height: 39px;\n    box-sizing: border-box;\n    border: 2px solid #494B4B !important;\n    border-radius: 12px !important;\n    font-weight: 500;\n}\n\n.check-icon{\n    height:11px\n}\n\n.error-text{\n    font-size: 12px;\n      color: var(--red-300);\n      width:0px !important;\n  }\n\n.cancel-btn-popup{\n    color: black;\n    border: 2px solid #E3E9F4;\n    background: var(--foundation-secondary-secondary-400, #fff);\n    border-radius: 11px;\n    margin-right:5px;\n    font-weight:600;\n}\n\n.cancel-btn-popup:hover{\n    background: #ededed;\n}\n\n//input-type file\ninput[type=\"file\"]{\n    display: none;\n }\n .custom-file-upload{\n    border: 2px solid #494B4B;\n    display: inline-block;\n    padding: 8px 18px;\n    cursor: pointer;\n    border-radius: 10px;\n    font-weight: 600;\n }\n .spacing-div {\n    margin-left: 12rem;\n }\n\n .modalPopup .spacing-div {margin-left: auto;}\n\n .spacing-div-sm {\n    margin-left: 18rem\n }\n\n //editUser Popup\n\n input[type='checkbox']{\n    width: 18px !important;\n    height: 18px !important;\n    margin-right: 10px;\n    margin-top: 5px;\n    -o-appearance: none;\n    appearance: none;\n    box-shadow: none;\n    font-size: 0.8em;\n    text-align: center;\n    line-height: 1.20em;\n    background: var(--foundation-neutral-neutral-100, #F4F7FB);\n    border:2px solid white;\n  }\n  \n  input[type='checkbox']:checked:after {\n    height: 20px !important;\n    content: \"🗸\";\n    padding: 2px;\n    font-weight: 600;\n    font-size: 1rem;\n    color: white;\n    background: var(--primary);\n    border: 2px solid var(--secondary-700);\n    border-radius: 1px;\n  }\n\n.edit-user {\n    background: var(--main-neutral-dark-theme-neutral-dark-theme-700, #343535) !important;\n    height: fit-content;\n    width: 595px;\n}\n\n.input-field{\n    width:250px\n}\n\n.toggle-bg{\n    position: relative;\n    display: inline-block;\n    width: 180px;\n    height: 31px;\n    color: black;\n}\n\n.toggle-slider{\n    position: absolute;\n    content: \"\";\n    height: 31px;\n    width: 95px;\n    left: -17px;\n    top: 0px;\n    background-color: #9CA2AB;\n    transition: 0.4s;\n}\n\n\n //teamInfoPopup\n\n .teamInfoPopup {\n    background: #343535;\n    height: fit-content;\n    width: 1050px;\n}\n\n.teamInfoGrid {\n    gap: 34rem\n}\n\n.vl {\n    border-left: 1px solid #ccc;\n    //height: 60px;\n    margin-top: -94px;\n  }\n\n.small-text{\n    font-size: 8px;\n}\n\n.badge-text{\n    font-size: 11px;\n    color: black;\n}\n\n.team-name {\n    min-width: 630px;\n    flex: 1 1;\n    padding: 10px;\n    box-sizing: border-box;\n    border: 1px solid #ccc;\n    border-radius: 5px;\n}\n\n.teamInfoSidebar{\n    margin-left: 50px;\n}\n\n.info-badge{\n    background-color: #EFF3F9;\n    padding: 5px;\n    width: 185px;\n    border-radius: 15px;\n}\n\n.badge-icon {\n    margin: 12px;\n    color: black;\n}\n\n.popup-text{\n    font-weight: 500;\n    font-size: 13px;\n}\n\n.date-text {\n    font-size: 11px;\n}\n\n.profile-cover{\n    width: 145px;\n    height: 145px;\n    margin: 15px;\n    //margin-top: -80px;\n}\n\n.img-div{\n    border-left: 1px solid #ccc;\n}\n\n.team-label{\n    height: 480px;\n}\n\nselect:invalid { color: rgba(255,255,255,0.35); }\nselect option {background-color: var(--foundation-neutral-dark-theme-neutral-dark-theme-600, #424444); color: var(--text-white-medium-emphasis, rgba(252, 252, 254, 0.6))}\n\n.team-mate {\n    background-image: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAFLSURBVHgBnZLfTcMwEMbv7Lhx/RQ2sASuEC+UDdoNwgSUDViBDWCCZgPYoGWC8ogEEt6APiGranLYSaiqJqmqfJJj6/78fPlkhD0liU6cEykA6ipSLJ37WsIR4f9BqfOUcj73keSgxhJsps5Z2wZgu+aCv9TEx20e3RCwKUN69iGNJFZCmDF0aShH32FJqfVhLjT6HA2lWbQ2KzVKQ4GUZtZ5wdA8VTXNC1hRQDlansN7F4CI1zkxaQCIcA0ni9sGADEv6Zxj2tXGoJhUJ2dbC0oTY/PT5nQcXzzUHs3beqPw2eZ0GzFcRBxWnJvMh97q/B0CTqop2rV7SFJeaobFKxFc7xcQUMYAkUoYZb/u874xQfl37sP6bSzElV9bHWKDwWa5XtvSZCVHHoYzJQ0cQk6Wh2TBD9XhRy8IQg8FSPAklpsz6Ktgetj/ANwtaoEESpAOAAAAAElFTkSuQmCC);\n    background-repeat: no-repeat;\n    background-position: 9px 14px;\n    min-width: 470px;\n    flex: 1 1;\n    padding: 10px;\n    box-sizing: border-box;\n    border: 1px solid #ccc;\n    border-radius: 10px;\n    margin-right: 12px;\n    padding-left: 29px;\n}\n\n.team-mate::placeholder {\n    color:#09082652;\n    font-size: 13px;\n  }\n\n  .switch {\n    position: relative;\n    display: inline-block;\n    width: 35px;\n    height: 12px;\n  }\n  \n  .switch input { \n    opacity: 0;\n    width: 0;\n    height: 0;\n  }\n  \n  .slider {\n    position: absolute;\n    cursor: pointer;\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    background-color: #E3E9F4;\n    -webkit-transition: .4s;\n    transition: .4s;\n  }\n  \n  .slider:before {\n    position: absolute;\n    content: \"\";\n    height: 16px;\n    width: 16px;\n    left: 1px;\n    top:-2px;\n    background-color: #9CA2AB;\n    transition: 0.4s;\n  }\n  \n  input:checked + .slider {\n    background-color :#E3E9F4;\n  }\n  \n  input:focus + .slider {\n    box-shadow: 0 0 1px var(--secondary-200);\n  }\n  \n  input:checked + .slider:before {\n    -webkit-transform: translateX(17px);\n    -ms-transform: translateX(17px);\n    transform: translateX(17px);\n    background-color: var(--secondary-700);\n  }\n\n  //addRoleInfoPopup css\n \n.role-info{\n    width:420px;\n}\n\n\n  //permissionPage\n\n  .permission-page{\n    overflow: scroll;\n    height: 43vh;\n}\n\n.value-text{\n    color: #DCE4F1;\n    font-size: 0.8rem;\n    font-style: normal;\n    font-weight: 600;\n    line-height: 60%;\n}\n\n.info-box{\n    padding-left: 15px;\n    padding-right: 15px;\n    border-left: 3px solid #DCE4F1;\n}\n\n.permission-type{\n    color: white;\n}\n\n.value-header{\n    color: #DCE4F1;\n}\n\n.switch {\n    position: relative;\n    display: inline-block;\n    width: 35px;\n    height: 12px;\n  }\n  \n  .switch input { \n    opacity: 0;\n    width: 0;\n    height: 0;\n  }\n  \n  .slider {\n    position: absolute;\n    cursor: pointer;\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    background-color: #E3E9F4;\n    -webkit-transition: .4s;\n    transition: .4s;\n  }\n  \n  .slider:before {\n    position: absolute;\n    content: \"\";\n    height: 31px;\n    width: 95px;\n    left: 0px;\n    top: 0px;\n    background-color: #88E133;\n    transition: 0.4s;\n  }\n\n  .toggle-btn-text{\n    position: absolute;\n    top:6px;\n    margin-left:17px;\n    font-weight:500;\n  }\n\n  .toggle-btn-dis-text{\n    position: absolute;\n    top:6px;\n    margin-left:104px;\n    font-weight:500;\n  }\n  \n  input:checked + .slider {\n    background-color: #E3E9F4;\n  }\n  \n  input:focus + .slider {\n    box-shadow: 0 0 1px var(--secondary-200);\n  }\n  \n  input:checked + .slider:before {\n    // -webkit-transform: translateX(90px);\n    // -ms-transform: translateX(90px);\n    transform: translateX(85px);\n    background-color: #FF8787;\n  }\n  \n  /* Rounded sliders */\n  .slider.round {\n    border-radius: 34px;\n  }\n  \n  .slider.round:before {\n    border-radius: 15px;\n  }\n\n  .toggle-checkbox {\n    display: none;\n    visibility: hidden !important;\n}\n  \n  .team-mates-scroll{\n    overflow-y: scroll;\n    height: 470px;\n  }\n\n  .team-leads-scroll{\n    overflow-y: scroll;\n    height: 330px;\n  }\n\n /* width */\n::-webkit-scrollbar {\n    width: 6px;\n  }\n  \n  /* Track */\n  ::-webkit-scrollbar-track {\n    background: #343535; \n  }\n   \n  /* Handle */\n  ::-webkit-scrollbar-thumb {\n    background: #494B4B; \n    border-radius: 20px;\n  }\n  \n  /* Handle on hover */\n  ::-webkit-scrollbar-thumb:hover {\n    background: #494B4B; \n  }\n\n\n  .info-icon, .info-icon:hover, .info-icon:focus {font-weight: normal; border: 1px solid var(--primary); font-style: italic; color: #ffffff; display: inline-block; font-size: 10px; width: 15px; height: 15px; line-height: 13px; text-align: center; border-radius: 50%; background-color: transparent; padding: 0; vertical-align: middle;}\n\n  form label {color: inherit;}\n\n  .tooltip, .tooltip-inner {color: #ffffff !important;}\n  //settings\n\n .custom-logo-upload{\n    border: 2px solid #E3E9F4;\n    display: inline-block;\n    padding: 8px 28px;\n    cursor: pointer;\n    border-radius: 10px;\n    font-weight: 600;\n    width: 150px;\n    margin-top:5px;\n }\n\n .red-btn{\n    border-radius: 9px;\n    border: 2px solid rgba(255, 255, 255, 0.8);\n    background: #FF6969;\n    color: var(--text-high-emphasis, #090826);\n    font-family: Inter;\n    font-size: 0.82rem;\n    font-style: normal;\n    font-weight: 600;\n    line-height: 143%;\n }\n\n .red-btn:hover{\n    background: #ff9c9c;\n    border: 2px solid #ff9c9c;\n }\n\n /* for actions dropdown */\n\n .btn-create {width: 30px; height: 30px; text-align: center; line-height: 30px; border-radius: 100%;}\n.btn-more-options i, .btn-create i {color: white;} \n div:has( > .more-options-wrapper){overflow: unset !important;} \n .more-options-wrapper {position: relative; overflow: unset !important; }\n.more-options-wrapper .btn-more-options {width: 30px; height: 30px; text-align: center; line-height: 30px; border-radius: 100%;}\n.more-options-wrapper .btn-more-options:hover, .btn-create:hover {background-color: #343535;}\n.more-options-wrapper .more-options {position: absolute; right: 0; top: 22px; background-color: #343535; border: 1px solid #232323; z-index: 9; padding: 13px 15px; text-align: center; border-radius: 14px; box-shadow: 10px 14px 74px 0px rgba(0, 0, 0, 0.5);}\n.items-row:last-of-type .more-options-wrapper .more-options {bottom: 22px; top: auto;}\n.more-options-wrapper .more-options > button { display: flex; align-items: center;}\n.more-options-wrapper .more-options > button:disabled {color: #bbbbbb;}\n.more-options-wrapper .more-options > button:not(:last-child) {margin-bottom: 15px;}\n.more-options-wrapper .more-options > button span {min-width: max-content; margin-left: 10px; padding: 4px 25px;} \n.more-options-wrapper .more-options > button span:hover {\n    background-color: var(--foundation-neutral-dark-theme-neutral-dark-theme-600, #424444);\n    padding: 4px 25px;\n    border-radius: 13px;\n}\nbutton.btn-remove{background-color: #232323;}\n\n}\n\n#root:has(.DarkTheme) ~ .tooltip.show {background-color: #000000; color: #ffffff; box-shadow: -3px 4px 16px 0 rgba(0, 0, 0, 0.5); position: relative; z-index: 9999999999;}\n#root:has(.DarkTheme) ~ .tooltip.show:after {border-right-color: #000000;}\n\n\n.Navheader-collapse > div {background-color: (--foundation-neutral-dark-theme-neutral-dark-theme-500, #494B4B);}\n.org-selector.pb-3:after {content: \"\"; display: block; width: calc(100% - 30px); height: 15px; margin: 0 15px; border-bottom: 2px solid rgba(109, 111, 111, 0.6352941176);}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
